(() => {
  const state = {
    cursorReady: false,
    clockReady: false,
    binaryReady: false,
    cartDrawerReady: false,
    shippingProtectionSyncing: false,
    rewardGiftSyncing: false,
    cartRewardProgress: null,
    rewardGiftVariantCache: new Map(),
    revealObserver: null,
    parallaxReady: false,
    swatchColorCache: new Map(),
    sizeModalEscReady: false,
    sizeModalCounter: 0,
  };

  function pad(num) {
    return String(num).padStart(2, "0");
  }

  function hasFineHover() {
    return window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
  }

  function activateBody() {
    if (document.querySelector(".auciel-control-chrome, .ac-section, .auciel-control-footer")) {
      document.body.classList.add("auciel-control-active");
    }
  }

  function initCursor() {
    if (state.cursorReady || !hasFineHover()) return;

    const cursor = document.querySelector("[data-ac-cursor]");
    const ring = document.querySelector("[data-ac-cursor-ring]");
    if (!cursor || !ring) return;

    if (cursor.parentElement !== document.body) document.body.appendChild(cursor);
    if (ring.parentElement !== document.body) document.body.appendChild(ring);

    let mouseX = 0;
    let mouseY = 0;
    let ringX = 0;
    let ringY = 0;

    document.addEventListener("mousemove", (event) => {
      mouseX = event.clientX;
      mouseY = event.clientY;
      cursor.style.left = `${mouseX}px`;
      cursor.style.top = `${mouseY}px`;
    });

    function animateRing() {
      ringX += (mouseX - ringX) * 0.12;
      ringY += (mouseY - ringY) * 0.12;
      ring.style.left = `${ringX}px`;
      ring.style.top = `${ringY}px`;
      requestAnimationFrame(animateRing);
    }

    document.addEventListener("mouseover", (event) => {
      if (!event.target.closest("a, button, input, textarea, .ac-product-card, .acc-card, .acp-thumb, .acf-item, .acf-sidebar__item, .acn-channel, .acn-attach")) return;
      cursor.style.width = "16px";
      cursor.style.height = "16px";
      ring.style.width = "52px";
      ring.style.height = "52px";
    });

    document.addEventListener("mouseout", (event) => {
      if (!event.target.closest("a, button, input, textarea, .ac-product-card, .acc-card, .acp-thumb, .acf-item, .acf-sidebar__item, .acn-channel, .acn-attach")) return;
      cursor.style.width = "8px";
      cursor.style.height = "8px";
      ring.style.width = "32px";
      ring.style.height = "32px";
    });

    animateRing();
    state.cursorReady = true;
  }

  function initClock() {
    if (state.clockReady) return;

    const liveTime = document.querySelector("[data-ac-live-time]");
    const liveDate = document.querySelector("[data-ac-live-date]");
    if (!liveTime && !liveDate) return;

    function updateClock() {
      const now = new Date();
      if (liveTime) {
        liveTime.textContent = `${pad(now.getUTCHours())}:${pad(now.getUTCMinutes())}:${pad(now.getUTCSeconds())}`;
      }
      if (liveDate) {
        liveDate.textContent = `${pad(now.getUTCDate())}.${pad(now.getUTCMonth() + 1)}.${String(now.getUTCFullYear()).slice(2)}`;
      }
    }

    updateClock();
    window.setInterval(updateClock, 1000);
    state.clockReady = true;
  }

  function randomBinary(length) {
    let value = "";
    for (let i = 0; i < length; i += 1) {
      value += `${Math.random() > 0.5 ? "1" : "0"} `;
    }
    return value;
  }

  function initBinary() {
    if (state.binaryReady) return;

    const strips = Array.from(document.querySelectorAll("[data-ac-binary-strip]"));
    if (!strips.length) return;

    strips.forEach((strip) => {
      strip.textContent = randomBinary(600);
    });

    window.setInterval(() => {
      strips.forEach((strip) => {
        const chars = strip.textContent.split("");
        const idx = Math.floor(Math.random() * chars.length);
        if (chars[idx] === "0") chars[idx] = "1";
        else if (chars[idx] === "1") chars[idx] = "0";
        strip.textContent = chars.join("");
      });
    }, 80);

    state.binaryReady = true;
  }

  function initReveals(root = document) {
    const reveals = Array.from(root.querySelectorAll(".ac-reveal:not([data-ac-reveal-ready])"));
    if (!reveals.length) return;

    if (!("IntersectionObserver" in window)) {
      reveals.forEach((item) => item.classList.add("is-visible"));
      return;
    }

    if (!state.revealObserver) {
      state.revealObserver = new IntersectionObserver((entries, observer) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          const delay = Number(entry.target.dataset.delay || 0);
          window.setTimeout(() => entry.target.classList.add("is-visible"), delay);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.1 });
    }

    reveals.forEach((item) => {
      item.dataset.acRevealReady = "true";
      state.revealObserver.observe(item);
    });
  }

  function initParallax() {
    if (state.parallaxReady) return;

    function onScroll() {
      const scrollY = window.scrollY || 0;
      document.querySelectorAll("[data-ac-parallax]").forEach((layer) => {
        const speed = Number(layer.dataset.acParallaxSpeed || 0.25);
        const scale = Number(layer.dataset.acParallaxScale || 1.05);
        const section = layer.closest(".ac-section");
        const sectionTop = section ? section.offsetTop : 0;
        const relY = scrollY - sectionTop;
        layer.style.transform = `scale(${scale}) translateY(${relY * speed}px)`;
      });
    }

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    state.parallaxReady = true;
  }

  function initTilt(root = document) {
    if (!hasFineHover()) return;

    root.querySelectorAll("[data-ac-tilt]:not([data-ac-tilt-ready])").forEach((card) => {
      card.dataset.acTiltReady = "true";

      card.addEventListener("mousemove", (event) => {
        const rect = card.getBoundingClientRect();
        const x = (event.clientX - rect.left) / rect.width - 0.5;
        const y = (event.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = `perspective(600px) rotateY(${x * 8}deg) rotateX(${-y * 8}deg)`;
      });

      card.addEventListener("mouseleave", () => {
        card.style.transform = "perspective(600px) rotateY(0deg) rotateX(0deg)";
      });
    });
  }

  function getShopifyRoot() {
    return window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : "/";
  }

  function cartEndpoint(path) {
    return `${getShopifyRoot()}${path.replace(/^\//, "")}`;
  }

  function getBundledCartSections() {
    const sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
      bubbles: true,
      detail: { sections: sectionsToBundle },
    }));
    return sectionsToBundle;
  }

  function getProtectionConfig() {
    const drawer = document.querySelector("cart-drawer.ac-cart-drawer");
    if (!drawer) return null;

    const variantId = Number(drawer.dataset.acProtectionVariantId || 0);
    return {
      variantId,
      available: drawer.dataset.acProtectionAvailable === "true",
      lineKey: drawer.dataset.acProtectionLineKey || "",
      autoAdd: drawer.dataset.acProtectionAutoAdd !== "false",
      preference: drawer.dataset.acProtectionPreference || "",
    };
  }

  function getRewardGiftConfig() {
    const drawer = document.querySelector("cart-drawer.ac-cart-drawer");
    if (!drawer) return null;

    const variantId = Number(drawer.dataset.acRewardGiftVariantId || 0);
    return {
      enabled: drawer.dataset.acRewardGiftEnabled === "true",
      variantId,
      available: drawer.dataset.acRewardGiftAvailable !== "false",
      lineKey: drawer.dataset.acRewardGiftLineKey || "",
      threshold: Number(drawer.dataset.acRewardGiftThreshold || 0),
      handle: drawer.dataset.acRewardGiftHandle || "free-gift",
      includeProtection: drawer.dataset.acRewardIncludeProtection === "true",
    };
  }

  async function resolveRewardGiftVariant(config) {
    if (!config) return null;

    if (config.variantId) {
      return {
        variantId: config.variantId,
        available: config.available,
      };
    }

    const handle = String(config.handle || "").trim();
    if (!handle) return null;

    if (state.rewardGiftVariantCache.has(handle)) {
      return state.rewardGiftVariantCache.get(handle);
    }

    try {
      const response = await fetch(cartEndpoint(`products/${encodeURIComponent(handle)}.js`), {
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });

      if (!response.ok) throw new Error(`Unable to resolve reward gift product: ${handle}`);

      const product = await response.json();
      const variants = Array.isArray(product.variants) ? product.variants : [];
      const variant = variants.find((item) => item.available) || variants[0];
      const resolved = variant ? {
        variantId: Number(variant.id || 0),
        available: variant.available !== false,
      } : null;

      state.rewardGiftVariantCache.set(handle, resolved);
      return resolved;
    } catch (error) {
      console.error(error);
      state.rewardGiftVariantCache.set(handle, null);
      return null;
    }
  }

  function readCartRewardProgress(element) {
    if (!element) return null;
    const progress = Number(element.dataset.acRewardProgressValue || "");
    if (Number.isFinite(progress)) return Math.max(0, Math.min(100, progress));
    return null;
  }

  function animateCartRewardProgress(element, options = {}) {
    const target = readCartRewardProgress(element);
    if (!element || target === null) return;

    const previous = state.cartRewardProgress;
    if (options.instant || previous === null || Math.abs(previous - target) < 0.25) {
      element.style.setProperty("--ac-reward-progress", `${target}%`);
      state.cartRewardProgress = target;
      return;
    }

    element.classList.add("is-reward-prep");
    element.style.setProperty("--ac-reward-progress", `${previous}%`);
    element.offsetWidth;

    window.requestAnimationFrame(() => {
      element.classList.remove("is-reward-prep");
      element.style.setProperty("--ac-reward-progress", `${target}%`);
      window.setTimeout(() => {
        state.cartRewardProgress = target;
      }, 760);
    });
  }

  function initCartRewardProgress() {
    const drawer = document.querySelector("cart-drawer.ac-cart-drawer");
    if (!drawer) return;

    const reward = drawer.querySelector("[data-ac-cart-rewards]");
    if (reward && !reward.dataset.acRewardProgressReady) {
      reward.dataset.acRewardProgressReady = "true";
      animateCartRewardProgress(reward, { instant: state.cartRewardProgress === null });
    }

    if (drawer.dataset.acRewardObserverReady) return;
    drawer.dataset.acRewardObserverReady = "true";

    const observer = new MutationObserver(() => {
      const nextReward = drawer.querySelector("[data-ac-cart-rewards]");
      if (!nextReward || nextReward.dataset.acRewardProgressReady) return;
      nextReward.dataset.acRewardProgressReady = "true";
      animateCartRewardProgress(nextReward);
    });

    observer.observe(drawer, { childList: true });
  }

  function normalizeCartRewardRows(root = document) {
    const rows = root.querySelectorAll(".ac-cart-reward-item, .ac-cart-item.is-reward-gift");
    rows.forEach((row) => {
      row.classList.remove("is-layout-ready");

      const images = Array.from(row.querySelectorAll("img"));
      const settle = () => {
        row.offsetHeight;
        row.classList.add("is-layout-ready");
        alignCartRewardRows(root);
      };

      if (!images.length || images.every((image) => image.complete)) {
        window.requestAnimationFrame(settle);
        return;
      }

      Promise.all(images.map((image) => {
        if (image.decode) return image.decode().catch(() => undefined);

        return new Promise((resolve) => {
          image.addEventListener("load", resolve, { once: true });
          image.addEventListener("error", resolve, { once: true });
        });
      })).then(() => window.requestAnimationFrame(settle));
    });
  }

  function alignCartRewardRows(root = document) {
    const scope = root.querySelector ? root : document;
    const normalName = scope.querySelector(".ac-cart-drawer__items .ac-cart-item:not(.is-reward-gift) .ac-cart-item__name");
    const rewardRows = Array.from(scope.querySelectorAll(".ac-cart-reward-item, .ac-cart-item.is-reward-gift"));

    if (!normalName || !rewardRows.length) return;

    rewardRows.forEach((row) => row.style.setProperty("--ac-reward-title-offset", "0px"));

    window.requestAnimationFrame(() => {
      const targetLeft = normalName.getBoundingClientRect().left;

      rewardRows.forEach((row) => {
        const rewardName = row.querySelector(".ac-cart-reward-item__name, .ac-cart-item__name");
        if (!rewardName) return;

        const rewardLeft = rewardName.getBoundingClientRect().left;
        const offset = targetLeft - rewardLeft;
        row.style.setProperty("--ac-reward-title-offset", `${Math.abs(offset) < 1 ? 0 : offset.toFixed(2)}px`);
      });
    });
  }

  function getExcludedCartVariantIds(extraVariantIds = [], options = {}) {
    const excludedVariantIds = [getRewardGiftConfig()?.variantId, ...extraVariantIds];

    if (!options.includeProtection) {
      excludedVariantIds.push(getProtectionConfig()?.variantId);
    }

    return excludedVariantIds
      .map((variantId) => Number(variantId || 0))
      .filter(Boolean);
  }

  function getCartLineByVariant(cart, variantId) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    return items.find((item) => Number(item.variant_id) === Number(variantId));
  }

  function getRegularCartCount(cart, extraExcludedVariantIds = []) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const excludedVariantIds = getExcludedCartVariantIds(extraExcludedVariantIds);

    return items.reduce((count, item) => {
      if (excludedVariantIds.includes(Number(item.variant_id))) return count;
      if (item.properties && item.properties._ac_reward_gift === "true") return count;
      return count + Number(item.quantity || 0);
    }, 0);
  }

  function getCartRewardSubtotal(cart, extraExcludedVariantIds = [], options = {}) {
    const items = Array.isArray(cart && cart.items) ? cart.items : [];
    const excludedVariantIds = getExcludedCartVariantIds(extraExcludedVariantIds, {
      includeProtection: Boolean(options.includeProtection),
    });

    return items.reduce((total, item) => {
      if (excludedVariantIds.includes(Number(item.variant_id))) return total;
      if (item.properties && item.properties._ac_reward_gift === "true") return total;
      return total + Number(item.final_line_price || 0);
    }, 0);
  }

  function getProtectionCartState(cart, variantId) {
    return {
      line: getCartLineByVariant(cart, variantId),
      regularCount: getRegularCartCount(cart),
    };
  }

  function updateProtectionAwareCartCounts(cart) {
    const counters = document.querySelectorAll("cart-count[data-ac-exclude-protection]");
    if (!counters.length || !cart) return;

    const regularCount = getRegularCartCount(cart);
    counters.forEach((counter) => {
      counter.textContent = String(regularCount);
    });
  }

  async function refreshProtectionAwareCartCounts() {
    try {
      const cartContent = await (await fetch(cartEndpoint("cart.js"))).json();
      updateProtectionAwareCartCounts(cartContent);
    } catch (error) {
      console.error(error);
    }
  }

  async function setShippingProtectionPreference(value) {
    await fetch(cartEndpoint("cart/update.js"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        attributes: {
          shipping_protection: value,
        },
      }),
    });
  }

  async function addShippingProtection(variantId, baseEvent = "shipping-protection:add") {
    if (!variantId || state.shippingProtectionSyncing) return;
    state.shippingProtectionSyncing = true;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      await setShippingProtectionPreference("enabled");

      const sectionsToBundle = getBundledCartSections();
      const formData = new FormData();
      formData.set("id", String(variantId));
      formData.set("quantity", "1");
      formData.set("sections", sectionsToBundle.join(","));
      formData.set("sections_url", `${getShopifyRoot()}variants/${variantId}`);

      const response = await fetch(cartEndpoint("cart/add.js"), {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || responseJson.message || "Unable to add shipping protection.");
      }

      const cartContent = await (await fetch(cartEndpoint("cart.js"))).json();
      cartContent.sections = responseJson.sections || {};

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent,
          cart: cartContent,
        },
      }));
    } catch (error) {
      console.error(error);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      state.shippingProtectionSyncing = false;
    }
  }

  async function removeShippingProtection(lineKey, preference = "disabled", baseEvent = "shipping-protection:remove") {
    if (state.shippingProtectionSyncing) return;

    if (!lineKey) {
      try {
        await setShippingProtectionPreference(preference);
        document.documentElement.dispatchEvent(new CustomEvent("cart:refresh", { bubbles: true }));
      } catch (error) {
        console.error(error);
      }
      return;
    }

    state.shippingProtectionSyncing = true;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      await setShippingProtectionPreference(preference);

      const sectionsToBundle = getBundledCartSections();
      const cartContent = await (await fetch(cartEndpoint("cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: sectionsToBundle.join(","),
        }),
      })).json();

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent,
          cart: cartContent,
        },
      }));
    } catch (error) {
      console.error(error);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      state.shippingProtectionSyncing = false;
    }
  }

  async function syncShippingProtection(cart, baseEvent = "shipping-protection:sync") {
    if (state.shippingProtectionSyncing) return;

    const config = getProtectionConfig();
    if (!config || !config.variantId || !cart) return;

    const { line, regularCount } = getProtectionCartState(cart, config.variantId);
    const preference = cart.attributes && Object.prototype.hasOwnProperty.call(cart.attributes, "shipping_protection")
      ? cart.attributes.shipping_protection
      : config.preference;

    if (regularCount === 0 && line) {
      await removeShippingProtection(line.key, "", "shipping-protection:cleanup");
      return;
    }

    if (config.autoAdd && config.available && regularCount > 0 && !line && preference !== "disabled") {
      await addShippingProtection(config.variantId, baseEvent);
    }
  }

  async function addRewardGift(variantId, baseEvent = "reward-gift:add") {
    if (!variantId || state.rewardGiftSyncing) return;
    state.rewardGiftSyncing = true;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      const sectionsToBundle = getBundledCartSections();
      const formData = new FormData();
      formData.set("id", String(variantId));
      formData.set("quantity", "1");
      formData.set("properties[_ac_reward_gift]", "true");
      formData.set("sections", sectionsToBundle.join(","));
      formData.set("sections_url", `${getShopifyRoot()}variants/${variantId}`);

      const response = await fetch(cartEndpoint("cart/add.js"), {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const responseJson = await response.json();

      if (!response.ok) {
        throw new Error(responseJson.description || responseJson.message || "Unable to add reward gift.");
      }

      const cartContent = await (await fetch(cartEndpoint("cart.js"))).json();
      cartContent.sections = responseJson.sections || {};

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent,
          cart: cartContent,
        },
      }));
    } catch (error) {
      console.error(error);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      state.rewardGiftSyncing = false;
    }
  }

  async function removeRewardGift(lineKey, baseEvent = "reward-gift:remove") {
    if (!lineKey || state.rewardGiftSyncing) return;
    state.rewardGiftSyncing = true;
    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      const sectionsToBundle = getBundledCartSections();
      const cartContent = await (await fetch(cartEndpoint("cart/change.js"), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: lineKey,
          quantity: 0,
          sections: sectionsToBundle.join(","),
        }),
      })).json();

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent,
          cart: cartContent,
        },
      }));
    } catch (error) {
      console.error(error);
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      state.rewardGiftSyncing = false;
    }
  }

  async function syncRewardGift(cart, baseEvent = "reward-gift:sync") {
    if (state.rewardGiftSyncing) return;

    const config = getRewardGiftConfig();
    if (!config || !config.enabled || !cart) return;

    const resolved = await resolveRewardGiftVariant(config);
    const variantId = Number(resolved && resolved.variantId || 0);
    if (!variantId) return;

    const line = getCartLineByVariant(cart, variantId);
    const regularCount = getRegularCartCount(cart, [variantId]);
    const subtotal = getCartRewardSubtotal(cart, [variantId], {
      includeProtection: config.includeProtection,
    });
    const shouldHaveGift = resolved.available && regularCount > 0 && subtotal >= config.threshold;

    if (shouldHaveGift && !line) {
      await addRewardGift(variantId, baseEvent);
      return;
    }

    if (!shouldHaveGift && line) {
      await removeRewardGift(line.key, baseEvent === "reward-gift:sync" ? "reward-gift:remove" : baseEvent);
    }
  }

  async function submitCartAdd(form, submitter) {
    const button = submitter && submitter.matches("button") ? submitter : form.querySelector('button[type="submit"]');
    const originalText = button ? button.textContent : "";

    if (button) {
      button.disabled = true;
      button.setAttribute("aria-busy", "true");
      button.textContent = "ADDING...";
    }

    document.documentElement.dispatchEvent(new CustomEvent("theme:loading:start", { bubbles: true }));

    try {
      const sectionsToBundle = [];
      document.documentElement.dispatchEvent(new CustomEvent("cart:prepare-bundled-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      }));

      const formData = new FormData(form);
      const variantId = formData.get("id");
      formData.set("sections", sectionsToBundle.join(","));
      if (variantId) formData.set("sections_url", `${getShopifyRoot()}variants/${variantId}`);

      const response = await fetch(cartEndpoint("cart/add.js"), {
        method: "POST",
        body: formData,
        headers: { "X-Requested-With": "XMLHttpRequest" },
      });
      const responseJson = await response.json();

      if (!response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent("cart:error", {
          bubbles: true,
          detail: { error: responseJson.description || responseJson.message || "Unable to add this unit." },
        }));
        throw new Error(responseJson.description || responseJson.message || "Unable to add this unit.");
      }

      const cartContent = await (await fetch(cartEndpoint("cart.js"))).json();
      cartContent.sections = responseJson.sections || {};

      document.documentElement.dispatchEvent(new CustomEvent("cart:change", {
        bubbles: true,
        detail: {
          baseEvent: "variant:add",
          cart: cartContent,
        },
      }));

      if (button && form.matches("[data-ac-cart-reco-form], [data-ac-collection-quick-form]")) {
        button.textContent = form.matches("[data-ac-collection-quick-form]") ? "SUCCESS" : "ADDED";
        button.classList.add("is-added");
        window.setTimeout(() => {
          button.textContent = originalText;
          button.classList.remove("is-added");
        }, 1400);
      }
    } catch (error) {
      if (button) button.textContent = "ERROR";
      window.setTimeout(() => {
        if (button) button.textContent = originalText;
      }, 1400);
      throw error;
    } finally {
      document.documentElement.dispatchEvent(new CustomEvent("theme:loading:end", { bubbles: true }));
      if (button) {
        button.disabled = false;
        button.removeAttribute("aria-busy");
        if (!form.matches("[data-ac-cart-reco-form], [data-ac-collection-quick-form]")) button.textContent = originalText;
      }
    }
  }

  function setCardVariantSelectorOpen(form, open) {
    const wrap = form.querySelector("[data-ac-card-variant-select-wrap]");
    const select = form.querySelector("[data-ac-card-variant-select]");
    const buttons = form.querySelectorAll("[data-ac-card-variant-toggle]");

    if (!wrap || !select) return;

    form.classList.toggle("is-selecting", open);
    wrap.hidden = !open;
    buttons.forEach((button) => button.setAttribute("aria-expanded", String(open)));

    if (open) {
      window.setTimeout(() => select.focus(), 0);
    }
  }

  function toggleCardVariantSelector(form) {
    const isOpening = !form.classList.contains("is-selecting");

    if (isOpening) {
      document.querySelectorAll("[data-ac-card-variant-form].is-selecting").forEach((otherForm) => {
        if (otherForm !== form) setCardVariantSelectorOpen(otherForm, false);
      });
    }

    setCardVariantSelectorOpen(form, isOpening);
  }

  function resetCardVariantSelector(form) {
    const card = form.closest(".ac-product-card, .ac-cart-reco-card");
    const scope = card || form;

    scope.querySelectorAll("[data-ac-card-variant-form]").forEach((item) => setCardVariantSelectorOpen(item, false));
    scope.querySelectorAll("[data-ac-card-variant-select]").forEach((select) => {
      select.value = "";
    });
    scope.querySelectorAll("[data-ac-card-variant-input]").forEach((input) => {
      input.value = "";
    });
  }

  function closeCardVariantSelectors(card) {
    if (!card) return;

    card.querySelectorAll("[data-ac-card-variant-form]").forEach((form) => {
      setCardVariantSelectorOpen(form, false);
    });

    const active = document.activeElement;
    if (active && card.contains(active) && typeof active.blur === "function") {
      active.blur();
    }
  }

  function getCardVariants(card) {
    if (!card) return [];
    if (card._acCardVariants) return card._acCardVariants;

    const script = card.querySelector("[data-ac-card-variants]");
    try {
      card._acCardVariants = JSON.parse(script ? script.textContent : "[]");
    } catch (error) {
      card._acCardVariants = [];
    }

    return card._acCardVariants;
  }

  function getCardSelectedOptions(card) {
    const selected = {};
    const activeSwatch = card.querySelector("[data-ac-card-swatch].is-active");
    if (activeSwatch && activeSwatch.dataset.optionPosition !== undefined) {
      selected[activeSwatch.dataset.optionPosition] = activeSwatch.dataset.optionValue || "";
    }

    card.querySelectorAll("[data-ac-card-variant-select]").forEach((select) => {
      if (!select.value || select.dataset.optionPosition === undefined) return;
      selected[select.dataset.optionPosition] = select.value;
    });

    return selected;
  }

  function findCardVariant(card, extraSelected = {}) {
    const variants = getCardVariants(card);
    const selected = { ...getCardSelectedOptions(card), ...extraSelected };
    const selectedEntries = Object.entries(selected).filter(([, value]) => value);

    if (!selectedEntries.length) return variants.find((variant) => variant.available) || variants[0] || null;

    const matches = variants.filter((variant) => selectedEntries.every(([position, value]) => {
      return String(variant.options[Number(position)] || "") === String(value);
    }));

    return matches.find((variant) => variant.available) || matches[0] || null;
  }

  function setCardMobileGalleryImage(card, imageUrl) {
    const gallery = card.querySelector("[data-ac-card-mobile-gallery]");
    if (!gallery || !imageUrl) return;

    const firstSlide = gallery.querySelector("img");
    if (!firstSlide) return;

    const restoreOpacity = () => {
      gallery.style.opacity = "";
    };

    if (firstSlide.getAttribute("src") !== imageUrl) {
      gallery.style.opacity = "0.35";
      firstSlide.addEventListener("load", restoreOpacity, { once: true });
      firstSlide.addEventListener("error", restoreOpacity, { once: true });
      firstSlide.setAttribute("src", imageUrl);
    }

    if (typeof gallery.scrollTo === "function") {
      gallery.scrollTo({ left: 0, behavior: "smooth" });
    } else {
      gallery.scrollLeft = 0;
    }
  }

  function setCardVariant(card, variant, options = {}) {
    if (!card || !variant) return;

    const { setInput = true, updateImage = true } = options;
    const image = card.querySelector(".ac-product-card__image");
    const price = card.querySelector("[data-ac-card-price]") || card.querySelector(".ac-product-card__price");
    const comparePrice = card.querySelector("[data-ac-card-compare-price]");
    const saleBadge = card.querySelector("[data-ac-card-sale-badge]");

    if (setInput) {
      card.querySelectorAll("[data-ac-card-variant-input]").forEach((input) => {
        input.value = variant.id || "";
      });
    } else {
      card.querySelectorAll("[data-ac-card-variant-input]").forEach((input) => {
        input.value = "";
      });
    }

    if (price && variant.price) price.textContent = variant.price;

    if (comparePrice) {
      const onSale = Boolean(variant.isOnSale && variant.compareAtPrice);
      comparePrice.hidden = !onSale;
      comparePrice.textContent = onSale ? variant.compareAtPrice : "";
    }

    if (saleBadge) {
      saleBadge.hidden = !Boolean(variant.isOnSale && variant.compareAtPrice);
    }

    card.querySelectorAll(".ac-product-card__quick-action").forEach((button) => {
      if (variant.price && !button.disabled) button.textContent = `ACQUIRE - ${variant.price}`;
    });

    if (updateImage && image && variant.image && image.getAttribute("src") !== variant.image) {
      const restoreOpacity = () => {
        image.style.opacity = "";
      };
      image.style.opacity = "0.35";
      image.addEventListener("load", restoreOpacity, { once: true });
      image.addEventListener("error", restoreOpacity, { once: true });
      image.setAttribute("src", variant.image);
    }

    if (updateImage && variant.image) {
      setCardMobileGalleryImage(card, variant.image);
    }
  }

  function refreshCardSelectorAvailability(card) {
    const select = card.querySelector("[data-ac-card-variant-select]");
    if (!select) return;

    const selected = getCardSelectedOptions(card);
    delete selected[select.dataset.optionPosition];

    Array.from(select.options).forEach((option) => {
      if (!option.value) return;

      const variant = findCardVariant(card, {
        ...selected,
        [select.dataset.optionPosition]: option.value,
      });

      option.disabled = !variant || !variant.available;
    });
  }

  function colorFallbackFromName(name = "") {
    const value = name.toLowerCase();
    if (value.includes("black") || value.includes("noir")) return "#111111";
    if (value.includes("white") || value.includes("cream") || value.includes("ivory")) return "#f0ece0";
    if (value.includes("beige") || value.includes("sand") || value.includes("tan") || value.includes("bone") || value.includes("natural") || value.includes("oat")) return "#b9a78a";
    if (value.includes("blue") || value.includes("navy")) return "#1e3f65";
    if (value.includes("green") || value.includes("olive") || value.includes("khaki")) return "#304735";
    if (value.includes("red") || value.includes("burgundy") || value.includes("maroon")) return "#7a2028";
    if (value.includes("grey") || value.includes("gray") || value.includes("charcoal")) return "#737373";
    if (value.includes("brown") || value.includes("espresso")) return "#5b3f2d";
    if (value.includes("purple") || value.includes("violet")) return "#55406e";
    if (value.includes("pink") || value.includes("rose")) return "#9b5565";
    if (value.includes("orange")) return "#b45f22";
    if (value.includes("yellow") || value.includes("gold")) return "#c5a24a";
    return "#2a2a2a";
  }

  function sampleImageColor(url, fallback) {
    if (!url) return Promise.resolve({ color: fallback, sampled: false });
    const cacheKey = `${url}|${fallback}`;
    if (state.swatchColorCache.has(cacheKey)) return state.swatchColorCache.get(cacheKey);

    const promise = new Promise((resolve) => {
      const img = new Image();
      img.crossOrigin = "anonymous";
      img.onload = () => {
        try {
          const canvas = document.createElement("canvas");
          const size = 40;
          canvas.width = size;
          canvas.height = size;
          const ctx = canvas.getContext("2d", { willReadFrequently: true });
          if (!ctx) {
            resolve({ color: fallback, sampled: false });
            return;
          }

          ctx.clearRect(0, 0, size, size);
          const scale = Math.min(size / img.naturalWidth, size / img.naturalHeight);
          const width = Math.max(1, Math.round(img.naturalWidth * scale));
          const height = Math.max(1, Math.round(img.naturalHeight * scale));
          const x = Math.round((size - width) / 2);
          const y = Math.round((size - height) / 2);
          ctx.drawImage(img, x, y, width, height);
          const data = ctx.getImageData(0, 0, size, size).data;
          const bins = new Map();

          const quantize = (channel) => Math.max(0, Math.min(255, Math.round(channel / 28) * 28));

          for (let i = 0; i < data.length; i += 4) {
            const alpha = data[i + 3];
            if (alpha < 40) continue;

            const r = data[i];
            const g = data[i + 1];
            const b = data[i + 2];
            const brightness = (r + g + b) / 3;
            if (brightness > 244) continue;

            const key = `${quantize(r)},${quantize(g)},${quantize(b)}`;
            const bin = bins.get(key) || { count: 0, r: 0, g: 0, b: 0 };
            bin.count += 1;
            bin.r += r;
            bin.g += g;
            bin.b += b;
            bins.set(key, bin);
          }

          if (!bins.size) {
            resolve({ color: fallback, sampled: false });
            return;
          }

          const dominant = Array.from(bins.values()).sort((a, b) => b.count - a.count)[0];
          resolve({
            color: `rgb(${Math.round(dominant.r / dominant.count)}, ${Math.round(dominant.g / dominant.count)}, ${Math.round(dominant.b / dominant.count)})`,
            sampled: true,
          });
        } catch (error) {
          resolve({ color: fallback, sampled: false });
        }
      };
      img.onerror = () => resolve({ color: fallback, sampled: false });
      img.src = url;
    });

    state.swatchColorCache.set(cacheKey, promise);
    return promise;
  }

  function initProductCardSwatches(root = document) {
    root.querySelectorAll(".ac-product-card:not([data-ac-card-swatches-ready])").forEach((card) => {
      card.dataset.acCardSwatchesReady = "true";
      card.addEventListener("mouseleave", () => {
        closeCardVariantSelectors(card);
      });

      const swatches = Array.from(card.querySelectorAll("[data-ac-card-swatch]"));
      if (!swatches.length) {
        refreshCardSelectorAvailability(card);
        return;
      }

      swatches.forEach((swatch) => {
        const nativeColor = swatch.dataset.swatchColor || "";
        const fallback = nativeColor || colorFallbackFromName(swatch.dataset.colorName || swatch.dataset.optionValue || "");
        const swatchImage = swatch.dataset.variantSwatchImage || swatch.dataset.variantImage || "";
        swatch.style.setProperty("--ac-card-swatch-color", fallback);
        if (swatchImage) {
          swatch.style.setProperty("--ac-card-swatch-image", `url("${swatchImage}")`);
        }
        sampleImageColor(swatchImage, fallback).then((result) => {
          swatch.style.setProperty("--ac-card-swatch-color", result.color);
          if (result.sampled || nativeColor) {
            swatch.style.removeProperty("--ac-card-swatch-image");
          }
        });

        swatch.addEventListener("click", () => {
          if (swatch.disabled) return;

          swatches.forEach((item) => {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });
          swatch.classList.add("is-active");
          swatch.setAttribute("aria-pressed", "true");

          refreshCardSelectorAvailability(card);
          const select = card.querySelector("[data-ac-card-variant-select]");
          const shouldSetInput = !select || Boolean(select.value);
          const variant = shouldSetInput
            ? findCardVariant(card)
            : getCardVariants(card).find((item) => String(item.id) === String(swatch.dataset.variantId));

          if (variant) {
            const swatchVariant = {
              ...variant,
              image: swatch.dataset.variantImage || variant.image,
              swatchImage: swatch.dataset.variantSwatchImage || variant.swatchImage,
            };
            setCardVariant(card, swatchVariant, { setInput: shouldSetInput });
          }
        });
      });

      refreshCardSelectorAvailability(card);
      const activeSwatch = card.querySelector("[data-ac-card-swatch].is-active") || swatches.find((item) => !item.disabled);
      if (activeSwatch && !activeSwatch.classList.contains("is-active")) {
        activeSwatch.click();
      } else if (activeSwatch) {
        const select = card.querySelector("[data-ac-card-variant-select]");
        const variant = !select || select.value
          ? findCardVariant(card)
          : getCardVariants(card).find((item) => String(item.id) === String(activeSwatch.dataset.variantId));
        if (variant) {
          setCardVariant(card, {
            ...variant,
            image: activeSwatch.dataset.variantImage || variant.image,
            swatchImage: activeSwatch.dataset.variantSwatchImage || variant.swatchImage,
          }, { setInput: !select || Boolean(select.value) });
        }
      }
    });
  }

  function initProductRecommendations(root = document) {
    const selector = "[data-ac-product-recommendations]:not([data-ac-recommendations-ready])";
    const sections = [];

    if (root.nodeType === 1 && root.matches(selector)) {
      sections.push(root);
    }

    root.querySelectorAll(selector).forEach((section) => sections.push(section));

    sections.forEach((section) => {
      section.dataset.acRecommendationsReady = "true";

      if (section.dataset.acRecommendationsManual === "true" || section.dataset.acRecommendationsLoaded === "true") {
        initProductCardSwatches(section);
        initTilt(section);
        initGlitch(section);
        return;
      }

      const sectionId = section.dataset.sectionId;
      const productId = section.dataset.productId;
      if (!sectionId || !productId) return;

      const url = new URL(`${getShopifyRoot()}recommendations/products`, window.location.origin);
      url.searchParams.set("product_id", productId);
      url.searchParams.set("section_id", sectionId);
      url.searchParams.set("limit", section.dataset.recommendationLimit || "8");
      url.searchParams.set("intent", section.dataset.recommendationIntent || "related");

      fetch(url.toString(), { priority: "low" })
        .then((response) => {
          if (!response.ok) throw new Error("Unable to load recommendations");
          return response.text();
        })
        .then((html) => {
          const parsed = new DOMParser().parseFromString(html, "text/html");
          const nextSection = parsed.querySelector("[data-ac-product-recommendations]");
          const nextRelated = nextSection ? nextSection.querySelector(".acp-related") : null;
          const nextGrid = nextRelated ? nextRelated.querySelector("[data-ac-related-grid]") : null;

          if (!nextRelated || !nextGrid || !nextGrid.children.length) {
            section.dataset.acRecommendationsLoaded = "true";
            if (!section.querySelector("[data-ac-related-grid]")?.children.length) {
              section.remove();
            }
            return;
          }

          const currentRelated = section.querySelector(".acp-related");
          if (currentRelated) {
            currentRelated.replaceWith(document.importNode(nextRelated, true));
          } else {
            section.appendChild(document.importNode(nextRelated, true));
          }

          section.dataset.acRecommendationsLoaded = "true";
          initReveals(section);
          initProductCardSwatches(section);
          initTilt(section);
          initGlitch(section);
        })
        .catch(() => {
          section.dataset.acRecommendationsLoaded = "true";
          if (!section.querySelector("[data-ac-related-grid]")?.children.length) {
            section.remove();
          }
        });
    });
  }

  function initCartDrawer() {
    if (state.cartDrawerReady) return;

    initCartRewardProgress();
    normalizeCartRewardRows();
    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(() => {
        normalizeCartRewardRows();
        alignCartRewardRows();
      }).catch(() => undefined);
    }

    const cartDrawer = document.querySelector("cart-drawer.ac-cart-drawer");
    if (cartDrawer && !cartDrawer.dataset.acRewardRowNormalizeReady) {
      cartDrawer.dataset.acRewardRowNormalizeReady = "true";
      cartDrawer.addEventListener("dialog:before-show", () => {
        normalizeCartRewardRows(cartDrawer);
        window.setTimeout(() => normalizeCartRewardRows(cartDrawer), 180);
      });
      cartDrawer.addEventListener("dialog:after-show", () => {
        normalizeCartRewardRows(cartDrawer);
        alignCartRewardRows(cartDrawer);
        window.setTimeout(() => normalizeCartRewardRows(cartDrawer), 120);
        window.setTimeout(() => alignCartRewardRows(cartDrawer), 260);
      });
    }

    document.addEventListener("click", (event) => {
      const variantToggle = event.target.closest("[data-ac-card-variant-toggle]");
      if (variantToggle && variantToggle.form) {
        event.preventDefault();
        toggleCardVariantSelector(variantToggle.form);
        return;
      }

      const submitter = event.target.closest("[data-ac-cart-reco-form] button[type='submit'], [data-ac-product-form] button[type='submit'], [data-ac-collection-quick-form] button[type='submit']");
      if (submitter && submitter.form) submitter.form._acSubmitter = submitter;
    });

    document.addEventListener("submit", (event) => {
      const form = event.target.closest("[data-ac-cart-reco-form], [data-ac-product-form], [data-ac-collection-quick-form]");
      if (!form) return;

      const submitter = event.submitter || form._acSubmitter;

      if (form.matches("[data-ac-product-form]") && submitter && submitter.matches("[data-ac-quick-buy]")) {
        return;
      }

      event.preventDefault();

      if (form.matches("[data-ac-card-variant-form]") && !new FormData(form).get("id")) {
        toggleCardVariantSelector(form);
        return;
      }

      submitCartAdd(form, submitter).catch((error) => console.error(error));
    });

    document.addEventListener("click", (event) => {
      const button = event.target.closest("[data-ac-cart-reco-scroll]");
      if (!button) return;

      const drawer = button.closest("cart-drawer");
      const track = drawer ? drawer.querySelector("[data-ac-cart-reco-track]") : document.querySelector("[data-ac-cart-reco-track]");
      if (!track) return;

      const direction = Number(button.dataset.acCartRecoScroll || 1);
      track.scrollBy({ left: direction * 152, behavior: "smooth" });
    });

    document.addEventListener("change", (event) => {
      const select = event.target.closest("[data-ac-card-variant-select]");
      if (!select || !select.form || !select.value) return;

      const form = select.form;
      const card = form.closest(".ac-product-card, .ac-cart-reco-card");
      const input = form.querySelector("[data-ac-card-variant-input]");
      const button = form.querySelector("[data-ac-card-variant-toggle]");
      const variant = findCardVariant(card);
      if (!input || !variant || !variant.available) return;

      setCardVariant(card, variant, { setInput: true });
      submitCartAdd(form, button)
        .then(() => resetCardVariantSelector(form))
        .catch((error) => console.error(error));
    });

    document.addEventListener("change", async (event) => {
      const input = event.target.closest("[data-ac-cart-protection]");
      if (!input) return;

      const row = input.closest("[data-ac-cart-protection-row]");
      if (row) {
        row.classList.toggle("is-active", input.checked);
        row.classList.remove("is-flashing");
        window.requestAnimationFrame(() => row.classList.add("is-flashing"));
      }

      const variantId = Number(input.dataset.protectionVariantId || getProtectionConfig()?.variantId || 0);
      const lineKey = input.dataset.protectionLineKey || getProtectionConfig()?.lineKey || "";

      if (input.checked) {
        await addShippingProtection(variantId, "shipping-protection:add");
      } else {
        await removeShippingProtection(lineKey, "disabled", "shipping-protection:remove");
      }
    });

    document.addEventListener("cart:change", (event) => {
      if (event.detail && event.detail.cart) {
        window.requestAnimationFrame(() => updateProtectionAwareCartCounts(event.detail.cart));
        window.setTimeout(() => updateProtectionAwareCartCounts(event.detail.cart), 0);
        window.setTimeout(initCartRewardProgress, 0);
        window.setTimeout(normalizeCartRewardRows, 0);
        window.setTimeout(normalizeCartRewardRows, 220);
      }

      if (!event.detail || !event.detail.cart) return;

      const baseEvent = String(event.detail.baseEvent || "");
      window.setTimeout(() => {
        if (!baseEvent.startsWith("shipping-protection:")) {
          syncShippingProtection(event.detail.cart, "shipping-protection:auto-add").catch((error) => console.error(error));
        }

        if (!baseEvent.startsWith("reward-gift:")) {
          syncRewardGift(event.detail.cart, "reward-gift:auto-sync").catch((error) => console.error(error));
        }
      }, 75);
    });

    document.addEventListener("cart:refresh", () => {
      window.setTimeout(refreshProtectionAwareCartCounts, 80);
      window.setTimeout(initCartRewardProgress, 100);
      window.setTimeout(normalizeCartRewardRows, 120);
      window.setTimeout(normalizeCartRewardRows, 320);
    });

    window.setTimeout(async () => {
      try {
        const cartContent = await (await fetch(cartEndpoint("cart.js"))).json();
        updateProtectionAwareCartCounts(cartContent);
        initCartRewardProgress();
        normalizeCartRewardRows();
        await syncShippingProtection(cartContent, "shipping-protection:auto-add");
        await syncRewardGift(cartContent, "reward-gift:auto-sync");
        window.setTimeout(normalizeCartRewardRows, 220);
      } catch (error) {
        console.error(error);
      }
    }, 100);

    state.cartDrawerReady = true;
  }

  function initNavChrome(root = document) {
    root.querySelectorAll("[data-ac-nav-chrome]:not([data-ac-nav-ready])").forEach((chrome) => {
      chrome.dataset.acNavReady = "true";

      const overlay = chrome.querySelector("[data-ac-nav-overlay]");
      const mega = chrome.querySelector("[data-ac-mega-menu]");
      const panels = Array.from(chrome.querySelectorAll("[data-ac-mega-panel]"));
      const triggers = Array.from(chrome.querySelectorAll("[data-ac-mega-trigger]"));
      const items = Array.from(chrome.querySelectorAll("[data-ac-mega-item]"));
      const mobileMenu = chrome.querySelector("[data-ac-mobile-menu]");
      const mobileToggle = chrome.querySelector("[data-ac-mobile-menu-toggle]");
      const mobileClose = chrome.querySelector("[data-ac-mobile-menu-close]");
      const mobileGhost = chrome.querySelector("[data-ac-mobile-ghost]");
      const mobileBody = chrome.querySelector(".ac-mobile-menu__body");
      let activePanel = "";
      let leaveTimer = null;
      let mobileOpen = false;

      function setOverlay(open) {
        if (overlay) overlay.classList.toggle("is-open", open);
      }

      function cancelClose() {
        if (leaveTimer) window.clearTimeout(leaveTimer);
        leaveTimer = null;
      }

      function openMega(panelId) {
        const target = panels.find((panel) => panel.dataset.acMegaPanel === panelId);
        if (!target || !mega) return;

        cancelClose();
        activePanel = panelId;
        panels.forEach((panel) => panel.classList.toggle("is-active", panel === target));
        triggers.forEach((trigger) => {
          const isActive = trigger.dataset.acMegaTrigger === panelId;
          trigger.setAttribute("aria-expanded", isActive ? "true" : "false");
        });
        items.forEach((item) => item.classList.toggle("is-open", item.dataset.acMegaItem === panelId));
        mega.classList.add("is-open");
        setOverlay(true);
      }

      function closeMega(clearOverlay = true) {
        cancelClose();
        activePanel = "";
        if (mega) mega.classList.remove("is-open");
        panels.forEach((panel) => panel.classList.remove("is-active"));
        triggers.forEach((trigger) => trigger.setAttribute("aria-expanded", "false"));
        items.forEach((item) => item.classList.remove("is-open"));
        if (clearOverlay && !mobileOpen) setOverlay(false);
      }

      function scheduleClose() {
        cancelClose();
        leaveTimer = window.setTimeout(() => closeMega(), 120);
      }

      function setMobile(open) {
        mobileOpen = open;
        if (mobileMenu) mobileMenu.classList.toggle("is-open", open);
        if (mobileToggle) {
          mobileToggle.classList.toggle("is-open", open);
          mobileToggle.setAttribute("aria-expanded", open ? "true" : "false");
        }
        setOverlay(open || Boolean(activePanel));
        document.body.style.overflow = open ? "hidden" : "";
      }

      function closeAll() {
        closeMega(false);
        setMobile(false);
        setOverlay(false);
      }

      triggers.forEach((trigger) => {
        const panelId = trigger.dataset.acMegaTrigger;
        const item = trigger.closest("[data-ac-mega-item]");

        if (item) {
          item.addEventListener("mouseenter", () => openMega(panelId));
          item.addEventListener("mouseleave", scheduleClose);
        }
      });

      if (mega) {
        mega.addEventListener("mouseenter", cancelClose);
        mega.addEventListener("mouseleave", scheduleClose);
      }

      chrome.querySelectorAll("[data-ac-mega-filter]").forEach((button) => {
        button.addEventListener("click", () => {
          const category = button.dataset.acMegaFilter || "all";
          chrome.querySelectorAll("[data-ac-mega-filter]").forEach((item) => {
            item.classList.toggle("is-active", item === button);
          });
          chrome.querySelectorAll("[data-ac-mega-product]").forEach((product) => {
            const matches = category === "all" || product.dataset.cat === category;
            product.classList.toggle("is-hidden", !matches);
          });
        });
      });

      if (mobileToggle) {
        mobileToggle.addEventListener("click", () => {
          closeMega(false);
          setMobile(!mobileOpen);
        });
      }

      if (mobileClose) mobileClose.addEventListener("click", closeAll);
      if (overlay) overlay.addEventListener("click", closeAll);

      chrome.querySelectorAll("[data-ac-mobile-sub-toggle]").forEach((button) => {
        button.addEventListener("click", () => {
          const targetId = button.dataset.acMobileSubToggle;
          const target = chrome.querySelector(`[data-ac-mobile-sub="${targetId}"]`);
          const isOpen = target && target.classList.contains("is-open");

          chrome.querySelectorAll("[data-ac-mobile-sub]").forEach((sub) => sub.classList.remove("is-open"));
          chrome.querySelectorAll("[data-ac-mobile-sub-toggle]").forEach((toggle) => {
            toggle.classList.remove("is-open");
            toggle.setAttribute("aria-expanded", "false");
          });

          if (target && !isOpen) {
            target.classList.add("is-open");
            button.classList.add("is-open");
            button.setAttribute("aria-expanded", "true");
          }
        });
      });

      function escapeHTML(value) {
        return String(value).replace(/[&<>"']/g, (char) => ({
          "&": "&amp;",
          "<": "&lt;",
          ">": "&gt;",
          "\"": "&quot;",
          "'": "&#039;",
        }[char]));
      }

      const mobileSearch = chrome.querySelector("[data-ac-mobile-search]");
      const mobileSearchClear = chrome.querySelector("[data-ac-mobile-search-clear]");
      const mobileSearchResults = chrome.querySelector("[data-ac-mobile-search-results]");
      const mobileSearchData = Array.from(chrome.querySelectorAll(".ac-mobile-product[data-search]")).map((item) => {
        const img = item.querySelector("img");
        const title = item.querySelector("strong");
        const meta = item.querySelector("small");
        return {
          href: item.href,
          image: img ? img.currentSrc || img.src : "",
          title: title ? title.textContent.trim() : item.textContent.trim(),
          meta: meta ? meta.textContent.trim() : "",
          search: (item.dataset.search || item.textContent).toLowerCase(),
        };
      });

      function runMobileSearch() {
        if (!mobileSearch || !mobileSearchResults) return;
        const query = mobileSearch.value.trim().toLowerCase();
        if (mobileSearchClear) mobileSearchClear.classList.toggle("is-visible", query.length > 0);

        if (!query) {
          mobileSearchResults.classList.remove("is-open");
          mobileSearchResults.innerHTML = "";
          return;
        }

        const hits = mobileSearchData.filter((item) => item.search.includes(query)).slice(0, 6);
        if (!hits.length) {
          mobileSearchResults.innerHTML = `<div class="ac-mobile-search__empty">NO UNITS MATCHING "${escapeHTML(query.toUpperCase())}"</div>`;
        } else {
          mobileSearchResults.innerHTML = hits.map((item) => `
            <a href="${escapeHTML(item.href)}">
              ${item.image ? `<img src="${escapeHTML(item.image)}" alt="">` : ""}
              <span><strong>${escapeHTML(item.title)}</strong><small>${escapeHTML(item.meta)}</small></span>
            </a>
          `).join("");
        }
        mobileSearchResults.classList.add("is-open");
      }

      if (mobileSearch) mobileSearch.addEventListener("input", runMobileSearch);
      if (mobileSearchClear) {
        mobileSearchClear.addEventListener("click", () => {
          if (!mobileSearch || !mobileSearchResults) return;
          mobileSearch.value = "";
          mobileSearchResults.innerHTML = "";
          mobileSearchResults.classList.remove("is-open");
          mobileSearchClear.classList.remove("is-visible");
          mobileSearch.focus();
        });
      }

      chrome.querySelectorAll(".ac-nav-action, .ac-mobile-menu a").forEach((link) => {
        link.addEventListener("click", () => {
          closeMega(false);
          if (link.closest(".ac-mobile-menu")) setMobile(false);
          setOverlay(false);
        });
      });

      if (mobileBody && mobileGhost) {
        mobileBody.addEventListener("scroll", () => {
          mobileGhost.style.transform = `translateY(${-mobileBody.scrollTop * 0.15}px)`;
        }, { passive: true });
      }

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") closeAll();
      });
    });
  }

  function getCoverSourceRect(img, width, height) {
    const naturalWidth = img.naturalWidth;
    const naturalHeight = img.naturalHeight;
    const sourceRatio = naturalWidth / naturalHeight;
    const targetRatio = width / height;

    if (sourceRatio > targetRatio) {
      const sourceWidth = naturalHeight * targetRatio;
      return {
        x: (naturalWidth - sourceWidth) / 2,
        y: 0,
        width: sourceWidth,
        height: naturalHeight,
      };
    }

    const sourceHeight = naturalWidth / targetRatio;
    return {
      x: 0,
      y: (naturalHeight - sourceHeight) / 2,
      width: naturalWidth,
      height: sourceHeight,
    };
  }

  function drawGlitch(canvas, img) {
    const width = img.offsetWidth;
    const height = img.offsetHeight;
    if (!width || !height || !img.complete || !img.naturalWidth) return;

    if (canvas.width !== width) {
      canvas.width = width;
      canvas.style.width = `${width}px`;
    }
    if (canvas.height !== height) {
      canvas.height = height;
      canvas.style.height = `${height}px`;
    }

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    const source = getCoverSourceRect(img, width, height);

    try {
      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
      ctx.clearRect(0, 0, width, height);
      ctx.drawImage(img, source.x, source.y, source.width, source.height, 0, 0, width, height);

      const slices = Math.floor(Math.random() * 4) + 1;
      for (let i = 0; i < slices; i += 1) {
        const targetY = Math.random() * height;
        const targetH = Math.random() * 18 + 2;
        const targetX = (Math.random() - 0.5) * 16;
        const visibleTargetH = Math.min(targetH, height - targetY);
        const sourceY = source.y + (targetY / height) * source.height;
        const sourceH = (visibleTargetH / height) * source.height;
        ctx.drawImage(img, source.x, sourceY, source.width, sourceH, targetX, targetY, width, visibleTargetH);
      }

      ctx.globalCompositeOperation = "screen";
      ctx.globalAlpha = 0.18;
      ctx.drawImage(img, source.x, source.y, source.width, source.height, 4, 0, width, height);
      ctx.globalAlpha = 0.12;
      ctx.drawImage(img, source.x, source.y, source.width, source.height, -4, 0, width, height);

      ctx.globalCompositeOperation = "source-over";
      ctx.globalAlpha = 1;
      const noiseLines = Math.floor(Math.random() * 3);
      for (let j = 0; j < noiseLines; j += 1) {
        const lineY = Math.floor(Math.random() * height);
        ctx.fillStyle = Math.random() > 0.5 ? "rgba(255,255,255,0.05)" : "rgba(0,0,0,0.12)";
        ctx.fillRect(0, lineY, width, Math.ceil(Math.random() * 2) + 1);
      }

      ctx.fillStyle = "rgba(0,0,0,0.14)";
      for (let y = 0; y < height; y += 4) {
        ctx.fillRect(0, y, width, 2);
      }
    } catch (error) {
      ctx.clearRect(0, 0, width, height);
    }
  }

  function initGlitch(root = document) {
    if (!hasFineHover()) return;

    root.querySelectorAll(".ac-product-card:not([data-ac-glitch-ready])").forEach((card) => {
      const img = card.querySelector(".ac-product-card__image");
      const canvas = card.querySelector(".ac-product-card__glitch");
      if (!img || !canvas) return;

      card.dataset.acGlitchReady = "true";
      let timer = null;
      let active = false;

      function loop() {
        if (!active) return;
        drawGlitch(canvas, img);
        const interval = Math.random() < 0.15 ? 16 : 60 + Math.random() * 100;
        timer = window.setTimeout(() => window.requestAnimationFrame(loop), interval);
      }

      card.addEventListener("mouseenter", () => {
        active = true;
        loop();
      });

      card.addEventListener("mouseleave", () => {
        active = false;
        if (timer) window.clearTimeout(timer);
        const ctx = canvas.getContext("2d");
        if (ctx) ctx.clearRect(0, 0, canvas.width, canvas.height);
      });
    });
  }

  function initSizingTools(root = document) {
    const sizeOrder = ["XS", "S", "M", "L", "XL"];
    const fitOrder = ["fitted", "standard", "relaxed"];
    const defaultFinishedChest = {
      XS: 42,
      S: 44,
      M: 46,
      L: 48,
      XL: 50,
    };
    const chestBands = [
      { label: "36-38\"", min: 36, max: 38, sample: 36 },
      { label: "39-40\"", min: 39, max: 40, sample: 39 },
      { label: "41-42\"", min: 41, max: 42, sample: 41 },
      { label: "43-44\"", min: 43, max: 44, sample: 43 },
      { label: "45-46\"", min: 45, max: 46, sample: 45 },
      { label: "47-48\"", min: 47, max: 48, sample: 47 },
    ];
    const fitCopy = {
      fitted: {
        label: "FITTED FIT",
        shortLabel: "FITTED",
        description: "FITTED sits closer through chest and shoulders. Use it when you want less ease than the standard AU CIEL silhouette.",
      },
      standard: {
        label: "STANDARD FIT",
        shortLabel: "STANDARD",
        description: "STANDARD is the intended AU CIEL fit: boxy through the body with enough room to hang cleanly.",
      },
      relaxed: {
        label: "RELAXED FIT",
        shortLabel: "RELAXED",
        description: "RELAXED gives more volume through the chest and body. Use it when you want a loose, layered silhouette.",
      },
    };

    const fallbackSpecs = {
      XS: { shoulder: "18.75\"", length: "27.25\"", height: "5'5\"-5'9\"" },
      S: { shoulder: "19.5\"", length: "28\"", height: "5'8\"-5'11\"" },
      M: { shoulder: "20.25\"", length: "28.75\"", height: "5'10\"-6'1\"" },
      L: { shoulder: "21\"", length: "29.5\"", height: "6'0\"-6'3\"" },
      XL: { shoulder: "21.75\"", length: "30.25\"", height: "6'2\"+" },
    };

    function clampNumber(value, min, max) {
      return Math.min(max, Math.max(min, value));
    }

    function readNumber(value, fallback) {
      const parsed = Number.parseFloat(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    }

    function buildSizes(tool) {
      return sizeOrder.map((id) => ({
        id,
        chest: readNumber(tool.dataset[`${id.toLowerCase()}Chest`], defaultFinishedChest[id]),
        shoulder: fallbackSpecs[id].shoulder,
        length: fallbackSpecs[id].length,
        height: fallbackSpecs[id].height,
      }));
    }

    function initSizingCanvas(tool) {
      const canvas = tool.querySelector("[data-ac-size-canvas]");
      if (!canvas || canvas.dataset.acSizeCanvasReady === "true") return;
      const context = canvas.getContext("2d");
      if (!context) return;

      canvas.dataset.acSizeCanvasReady = "true";
      const particles = Array.from({ length: 42 }, () => ({
        x: Math.random(),
        y: Math.random(),
        vx: (Math.random() - 0.5) * 0.0005,
        vy: (Math.random() - 0.5) * 0.0005,
        r: Math.random() * 1.4 + 0.4,
      }));
      let width = 0;
      let height = 0;
      let tick = 0;

      function resize() {
        const rect = canvas.getBoundingClientRect();
        width = Math.max(1, Math.floor(rect.width));
        height = Math.max(1, Math.floor(rect.height));
        canvas.width = width;
        canvas.height = height;
      }

      function draw() {
        if (!canvas.isConnected) return;
        if (canvas.width !== Math.floor(canvas.getBoundingClientRect().width)) resize();

        tick += 1;
        context.clearRect(0, 0, width, height);
        context.strokeStyle = "rgba(240,240,238,0.045)";
        context.lineWidth = 1;

        for (let y = 0; y < height; y += 82) {
          context.beginPath();
          for (let x = 0; x <= width; x += 18) {
            const wave = Math.sin((x + tick) * 0.006 + y * 0.01) * 5;
            if (x === 0) context.moveTo(x, y + wave);
            else context.lineTo(x, y + wave);
          }
          context.stroke();
        }

        particles.forEach((particle) => {
          particle.x += particle.vx;
          particle.y += particle.vy;
          if (particle.x < 0) particle.x = 1;
          if (particle.x > 1) particle.x = 0;
          if (particle.y < 0) particle.y = 1;
          if (particle.y > 1) particle.y = 0;

          context.beginPath();
          context.arc(particle.x * width, particle.y * height, particle.r, 0, Math.PI * 2);
          context.fillStyle = "rgba(240,240,238,0.12)";
          context.fill();
        });

        window.requestAnimationFrame(draw);
      }

      resize();
      window.addEventListener("resize", resize, { passive: true });
      draw();
    }

    function closeSizingModal(modal) {
      if (!modal) return;
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      modal.hidden = true;
      document.documentElement.classList.remove("ac-size-modal-open");
    }

    function openSizingModal(trigger) {
      const productPage = trigger.closest("[data-ac-product-page]");
      const targetId = trigger.dataset.acSizeModalTarget || (productPage ? productPage.dataset.acSizeProductPageId : "");
      const modal = targetId
        ? document.querySelector(`[data-ac-size-modal][data-ac-size-product-page-id="${targetId}"]`)
        : document.querySelector("[data-ac-size-modal]");

      if (!modal) {
        document.documentElement.classList.remove("ac-size-modal-open");
        return;
      }

      modal.hidden = false;
      modal.setAttribute("aria-hidden", "false");
      modal.classList.add("is-open");
      document.documentElement.classList.add("ac-size-modal-open");

      const closeButton = modal.querySelector("[data-ac-size-modal-close]");
      if (closeButton && closeButton.focus) closeButton.focus({ preventScroll: true });
    }

    root.querySelectorAll("[data-ac-size-modal-open]:not([data-ac-size-modal-open-ready])").forEach((trigger) => {
      trigger.dataset.acSizeModalOpenReady = "true";
      const productPage = trigger.closest("[data-ac-product-page]");
      if (productPage) {
        if (!productPage.dataset.acSizeProductPageId) {
          state.sizeModalCounter += 1;
          productPage.dataset.acSizeProductPageId = `ac-size-product-page-${state.sizeModalCounter}`;
        }
        trigger.dataset.acSizeModalTarget = productPage.dataset.acSizeProductPageId;
      }
      trigger.addEventListener("click", () => openSizingModal(trigger));
    });

    root.querySelectorAll("[data-ac-size-modal]:not([data-ac-size-modal-ready])").forEach((modal) => {
      modal.dataset.acSizeModalReady = "true";
      const productPage = modal.closest("[data-ac-product-page]");
      if (productPage) {
        if (!productPage.dataset.acSizeProductPageId) {
          state.sizeModalCounter += 1;
          productPage.dataset.acSizeProductPageId = `ac-size-product-page-${state.sizeModalCounter}`;
        }
        modal.dataset.acSizeProductPageId = productPage.dataset.acSizeProductPageId;
      }

      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }

      modal.querySelectorAll("[data-ac-size-modal-close]").forEach((closer) => {
        closer.addEventListener("click", () => closeSizingModal(modal));
      });
    });

    if (!state.sizeModalEscReady) {
      document.addEventListener("keydown", (event) => {
        if (event.key !== "Escape") return;
        closeSizingModal(document.querySelector("[data-ac-size-modal].is-open"));
      });
      state.sizeModalEscReady = true;
    }

    root.querySelectorAll("[data-ac-sizing-tool]:not([data-ac-sizing-ready])").forEach((tool) => {
      tool.dataset.acSizingReady = "true";
      initSizingCanvas(tool);

      const sizes = buildSizes(tool);
      const min = readNumber(tool.dataset.sizeMin, 36);
      const max = readNumber(tool.dataset.sizeMax, 48);
      const slider = tool.querySelector("[data-ac-size-slider]");
      const fitButtons = Array.from(tool.querySelectorAll("[data-ac-size-fit]"));
      const chestValue = tool.querySelector("[data-ac-size-chest]");
      const cmValue = tool.querySelector("[data-ac-size-cm]");
      const status = tool.querySelector("[data-ac-size-status]");
      const fitDescription = tool.querySelector("[data-ac-size-fit-desc]");
      const currentSize = tool.querySelector("[data-ac-size-current]");
      const currentFit = tool.querySelector("[data-ac-size-current-fit]");
      const roomLabel = tool.querySelector("[data-ac-size-room]");
      const matchLabel = tool.querySelector("[data-ac-size-match]");
      const specChest = tool.querySelector("[data-ac-size-spec-chest]");
      const specLength = tool.querySelector("[data-ac-size-spec-length]");
      const specShoulder = tool.querySelector("[data-ac-size-spec-shoulder]");
      const specHeight = tool.querySelector("[data-ac-size-spec-height]");
      const confidenceFill = tool.querySelector("[data-ac-size-confidence]");
      const confidenceLabel = tool.querySelector("[data-ac-size-confidence-label]");
      const nudge = tool.querySelector("[data-ac-size-nudge]");
      const matrixBody = tool.querySelector("[data-ac-size-matrix]");
      const matrixScroll = tool.querySelector("[data-ac-size-matrix-scroll]");
      const specsBody = tool.querySelector("[data-ac-size-specs]");
      const applyButton = tool.querySelector("[data-ac-size-apply]");

      let fit = fitCopy[tool.dataset.defaultFit] ? tool.dataset.defaultFit : "standard";
      let chest = clampNumber(readNumber(tool.dataset.sizeInitial, 40), min, max);
      let previousSize = "";

      function activeBandFor(measurement) {
        return chestBands.find((band) => measurement >= band.min && measurement <= band.max) || chestBands[0];
      }

      function closestStandardIndex(measurement) {
        const targetChest = measurement + 5;
        let index = 0;
        let diff = Number.POSITIVE_INFINITY;

        sizes.forEach((size, sizeIndex) => {
          const nextDiff = Math.abs(size.chest - targetChest);
          if (nextDiff < diff) {
            index = sizeIndex;
            diff = nextDiff;
          }
        });

        return index;
      }

      function mappedFitIndexes(measurement) {
        const anchorIndex = closestStandardIndex(measurement);
        const anchorEase = sizes[anchorIndex].chest - measurement;
        const raw = anchorEase >= 4
          ? {
            fitted: anchorIndex - 1,
            standard: anchorIndex,
            relaxed: anchorIndex + 1,
          }
          : {
            fitted: anchorIndex,
            standard: anchorIndex + 1,
            relaxed: anchorIndex + 2,
          };

        return fitOrder.reduce((indexes, fitName) => {
          indexes[fitName] = raw[fitName] >= 0 && raw[fitName] < sizes.length ? raw[fitName] : null;
          return indexes;
        }, {});
      }

      function fallbackFitFor(indexes, fitName) {
        const fallbackOrder = {
          fitted: ["standard", "relaxed"],
          standard: ["fitted", "relaxed"],
          relaxed: ["standard", "fitted"],
        };

        return fallbackOrder[fitName].find((fallbackFit) => indexes[fallbackFit] !== null) || "";
      }

      function recommendationFor(measurement, fitName) {
        const indexes = mappedFitIndexes(measurement);
        const exactIndex = indexes[fitName];
        const fallbackFit = exactIndex === null ? fallbackFitFor(indexes, fitName) : "";
        const selectedIndex = exactIndex !== null
          ? exactIndex
          : fallbackFit && indexes[fallbackFit] !== null
            ? indexes[fallbackFit]
            : fitName === "fitted" ? 0 : sizes.length - 1;
        const selectedSize = sizes[selectedIndex];
        const actualRoom = selectedSize.chest - measurement;
        const idealRoom = fitName === "fitted" ? 3 : fitName === "relaxed" ? 7 : 5;
        const available = exactIndex !== null;
        const confidence = available
          ? clampNumber(Math.round(99 - Math.abs(actualRoom - idealRoom) * 6), 78, 99)
          : 64;
        const message = available
          ? ""
          : `${fitCopy[fitName].shortLabel} is outside this size run at ${measurement}". ${selectedSize.id}${fallbackFit ? ` in ${fitCopy[fallbackFit].shortLabel}` : ""} is the closest AU CIEL coordinate.`;

        return {
          size: selectedSize,
          actualRoom,
          confidence,
          message,
          available,
          fallbackFit,
        };
      }

      function renderSpecs(activeId) {
        if (!specsBody) return;
        specsBody.innerHTML = sizes.map((size) => `
          <tr class="${size.id === activeId ? "is-active-row" : ""}">
            <td>${size.id}</td>
            <td>${size.chest}"</td>
            <td>${size.shoulder}</td>
            <td>${size.length}</td>
            <td>${size.height}</td>
          </tr>
        `).join("");
      }

      function renderMatrix(activeRecommendation, smooth = false) {
        if (!matrixBody) return;
        const activeBand = activeBandFor(chest);
        const rows = chestBands.map((band) => {
          const isActiveRow = band === activeBand;
          const cells = fitOrder.map((fitName) => {
            const cell = recommendationFor(band.sample, fitName);
            const isActiveFit = fitName === fit;
            const isFallbackCell = isActiveRow && activeRecommendation && !activeRecommendation.available && fitName === activeRecommendation.fallbackFit;
            const classes = [
              isActiveFit ? "is-active-column" : "",
              isActiveRow && isActiveFit && cell.available ? "is-active-cell" : "",
              !cell.available ? "is-unavailable-cell" : "",
              isFallbackCell ? "is-fallback-cell" : "",
            ].filter(Boolean).join(" ");

            return `<td class="${classes}">${cell.available ? cell.size.id : "—"}</td>`;
          }).join("");

          return `
            <tr class="${isActiveRow ? "is-active-row" : ""}">
              <td>${band.label}</td>
              ${cells}
            </tr>
          `;
        });

        matrixBody.innerHTML = rows.join("");
        tool.querySelectorAll(".ac-size-matrix th").forEach((heading) => heading.classList.remove("is-active"));
        tool.querySelectorAll(".ac-size-matrix th button[data-ac-size-fit]").forEach((button) => {
          if (button.dataset.acSizeFit !== fit) return;
          const heading = button.closest("th");
          if (heading) heading.classList.add("is-active");
        });

        if (matrixScroll) {
          const activeRow = matrixBody.querySelector(".is-active-row");
          if (activeRow) {
            const targetTop = activeRow.offsetTop - matrixScroll.clientHeight / 2 + activeRow.clientHeight / 2;
            matrixScroll.scrollTo({ top: Math.max(0, targetTop), behavior: smooth ? "smooth" : "auto" });
          }
        }

        if (activeRecommendation && activeRecommendation.size) {
          tool.dataset.currentSize = activeRecommendation.size.id;
        }
      }

      function update(smooth = false) {
        const rec = recommendationFor(chest, fit);
        const indexes = mappedFitIndexes(chest);
        const percent = ((chest - min) / (max - min)) * 100;

        if (slider) {
          slider.value = chest;
          slider.style.setProperty("--pct", `${percent}%`);
        }
        if (chestValue) chestValue.textContent = String(chest);
        if (cmValue) cmValue.textContent = `${Math.round(chest * 2.54)} CM`;
        if (status) status.textContent = fitCopy[fit].label;
        if (fitDescription) fitDescription.textContent = fitCopy[fit].description;

        fitButtons.forEach((button) => {
          const isActive = button.dataset.acSizeFit === fit;
          const isAvailable = indexes[button.dataset.acSizeFit] !== null;
          button.classList.toggle("is-active", isActive);
          button.classList.toggle("is-unavailable", !isAvailable);
          button.setAttribute("aria-pressed", isActive ? "true" : "false");
        });

        if (currentSize) {
          currentSize.textContent = rec.size.id;
          if (previousSize !== rec.size.id) {
            currentSize.classList.remove("is-bumping");
            void currentSize.offsetWidth;
            currentSize.classList.add("is-bumping");
          }
        }
        previousSize = rec.size.id;

        if (currentFit) currentFit.textContent = fitCopy[fit].label;
        if (roomLabel) roomLabel.textContent = `ABOUT ${rec.actualRoom}" OF ROOM`;
        if (matchLabel) matchLabel.textContent = rec.available ? "MATCH FOUND" : "CLOSEST FIT";
        if (specChest) specChest.textContent = `${rec.size.chest}"`;
        if (specLength) specLength.textContent = rec.size.length;
        if (specShoulder) specShoulder.textContent = rec.size.shoulder;
        if (specHeight) specHeight.textContent = rec.size.height;
        if (confidenceFill) confidenceFill.style.width = `${rec.confidence}%`;
        if (confidenceLabel) confidenceLabel.textContent = `${rec.confidence}%`;
        if (nudge) {
          nudge.hidden = !rec.message;
          nudge.textContent = rec.message;
        }
        if (applyButton) applyButton.textContent = `SELECT ${rec.size.id}`;

        renderMatrix(rec, smooth);
        renderSpecs(rec.size.id);
      }

      fitButtons.forEach((button) => {
        button.addEventListener("click", () => {
          fit = fitCopy[button.dataset.acSizeFit] ? button.dataset.acSizeFit : fit;
          update(true);
        });
      });

      if (slider) {
        slider.addEventListener("input", () => {
          chest = clampNumber(readNumber(slider.value, chest), min, max);
          update(true);
        });
      }

      if (applyButton) {
        applyButton.addEventListener("click", () => {
          const modal = tool.closest("[data-ac-size-modal]");
          const productPageId = modal ? modal.dataset.acSizeProductPageId : "";
          const productPage = productPageId
            ? document.querySelector(`[data-ac-product-page][data-ac-size-product-page-id="${productPageId}"]`)
            : tool.closest("[data-ac-product-page]");
          const size = tool.dataset.currentSize;
          if (!productPage || !size) return;

          const sizeButton = Array.from(productPage.querySelectorAll(".acp-size-btn[data-ac-option-choice]"))
            .find((button) => (button.dataset.value || "").trim().toUpperCase() === size.toUpperCase());

          if (sizeButton) {
            sizeButton.click();
            closeSizingModal(modal);
            sizeButton.focus({ preventScroll: true });
          }
        });
      }

      update(false);
    });
  }

  function initProductPage(root = document) {
    root.querySelectorAll("[data-ac-product-page]:not([data-ac-product-ready])").forEach((page) => {
      page.dataset.acProductReady = "true";

      const mainImage = page.querySelector("[data-ac-product-main-image]");
      const imageFrame = page.querySelector(".acp-image-frame");
      const thumbs = Array.from(page.querySelectorAll("[data-ac-product-thumb]"));
      let activeImageIndex = Math.max(thumbs.findIndex((thumb) => thumb.classList.contains("is-active")), 0);

      function absoluteImageUrl(src) {
        if (!src) return "";
        try {
          return new URL(src, window.location.origin).href;
        } catch (error) {
          return src;
        }
      }

      function sameImageUrl(a, b) {
        return absoluteImageUrl(a) === absoluteImageUrl(b);
      }

      function setMainImage(src, alt) {
        if (!mainImage || !src) return;
        if (sameImageUrl(mainImage.currentSrc || mainImage.src, src)) {
          if (alt) mainImage.alt = alt;
          return;
        }

        mainImage.classList.add("is-changing");
        window.setTimeout(() => {
          mainImage.src = src;
          if (alt) mainImage.alt = alt;
          mainImage.addEventListener("load", () => {
            mainImage.classList.remove("is-changing");
          }, { once: true });
          window.setTimeout(() => mainImage.classList.remove("is-changing"), 600);
        }, 120);
      }

      function showProductImage(index) {
        if (!thumbs.length) return;
        const nextIndex = (index + thumbs.length) % thumbs.length;
        const thumb = thumbs[nextIndex];
        const nextSrc = thumb.dataset.acProductThumb;
        if (!thumb || !nextSrc) return;

        activeImageIndex = nextIndex;
        thumbs.forEach((item) => item.classList.toggle("is-active", item === thumb));

        setMainImage(nextSrc, thumb.querySelector("img")?.alt);
      }

      function showVariantImage(variant) {
        if (!variant || !variant.image) return;

        const thumbIndex = thumbs.findIndex((thumb) => sameImageUrl(thumb.dataset.acProductThumb, variant.image));
        if (thumbIndex >= 0) {
          showProductImage(thumbIndex);
          return;
        }

        thumbs.forEach((thumb) => thumb.classList.remove("is-active"));
        setMainImage(variant.image, variant.imageAlt);
      }

      thumbs.forEach((thumb, index) => {
        thumb.addEventListener("click", () => showProductImage(index));
      });

      if (imageFrame && thumbs.length > 1) {
        let touchStartX = 0;
        let touchStartY = 0;

        imageFrame.addEventListener("touchstart", (event) => {
          const touch = event.touches[0];
          touchStartX = touch ? touch.clientX : 0;
          touchStartY = touch ? touch.clientY : 0;
        }, { passive: true });

        imageFrame.addEventListener("touchend", (event) => {
          const touch = event.changedTouches[0];
          if (!touch) return;

          const dx = touch.clientX - touchStartX;
          const dy = touch.clientY - touchStartY;
          if (Math.abs(dx) < 42 || Math.abs(dx) < Math.abs(dy) * 1.25) return;

          showProductImage(activeImageIndex + (dx < 0 ? 1 : -1));
        }, { passive: true });
      }

      page.querySelectorAll("[data-ac-spec-trigger]").forEach((trigger) => {
        trigger.addEventListener("click", () => {
          const item = trigger.closest(".acp-spec-item");
          if (item) item.classList.toggle("is-open");
        });
      });

      const form = page.querySelector("[data-ac-product-form]");
      if (!form) return;

      const variantsScript = form.querySelector("[data-ac-product-variants]");
      const variantInput = form.querySelector("[data-ac-variant-id]");
      const addButton = form.querySelector("[data-ac-add-button]");
      const quickBuyButton = form.querySelector("[data-ac-quick-buy]");
      const price = page.querySelector("[data-ac-product-price]");
      const comparePrice = page.querySelector("[data-ac-product-compare-price]");
      const status = page.querySelector("[data-ac-product-status]");
      let variants = [];

      try {
        variants = JSON.parse(variantsScript ? variantsScript.textContent : "[]");
      } catch (error) {
        variants = [];
      }

      form.querySelectorAll(".acp-swatch[data-ac-option-choice]").forEach((swatch) => {
        const nativeColor = swatch.dataset.swatchColor || "";
        const fallback = nativeColor || colorFallbackFromName(swatch.dataset.colorName || swatch.dataset.value || "");
        const swatchImage = swatch.dataset.variantSwatchImage || swatch.dataset.variantImage || "";

        swatch.style.setProperty("--swatch-color", fallback);
        if (swatchImage) {
          swatch.style.setProperty("--swatch-image", `url("${swatchImage}")`);
        }

        sampleImageColor(swatchImage, fallback).then((result) => {
          swatch.style.setProperty("--swatch-color", result.color);
          if (result.sampled || nativeColor) {
            swatch.style.removeProperty("--swatch-image");
          }
        });
      });

      function selectedOptions() {
        return Array.from(form.querySelectorAll("[data-ac-option-group]"))
          .sort((a, b) => Number(a.dataset.optionPosition) - Number(b.dataset.optionPosition))
          .map((group) => {
            const active = group.querySelector("[data-ac-option-choice].is-active");
            return active ? active.dataset.value : "";
          });
      }

      function setVariant(sourceChoice = null) {
        const selected = selectedOptions();
        const variant = selected.length
          ? variants.find((item) => item.options.every((option, index) => option === selected[index]))
          : variants[0];
        const available = Boolean(variant && variant.available);
        const activeImageChoice = sourceChoice && sourceChoice.matches(".acp-swatch[data-variant-image]")
          ? sourceChoice
          : form.querySelector(".acp-swatch.is-active[data-variant-image]");
        const imageVariant = variant && activeImageChoice && activeImageChoice.dataset.variantImage
          ? {
            ...variant,
            image: activeImageChoice.dataset.variantImage,
            imageAlt: activeImageChoice.dataset.variantImageAlt || variant.imageAlt,
          }
          : variant;

        if (variantInput && variant) variantInput.value = variant.id;
        if (price && variant) price.textContent = variant.priceLabel;
        if (comparePrice && variant) {
          const onSale = Boolean(variant.isOnSale && variant.compareAtPrice);
          comparePrice.hidden = !onSale;
          comparePrice.textContent = onSale ? variant.compareAtPrice : "";
        }
        if (imageVariant) showVariantImage(imageVariant);

        if (addButton) {
          addButton.disabled = !available;
          addButton.textContent = available && variant
            ? `${addButton.dataset.acAddLabel} - ${variant.priceLabel}`
            : addButton.dataset.acSoldOutLabel;
        }

        if (quickBuyButton) {
          quickBuyButton.disabled = !available;
          quickBuyButton.textContent = available && variant
            ? `${quickBuyButton.dataset.acQuickBuyLabel} - ${variant.priceLabel}`
            : quickBuyButton.dataset.acSoldOutLabel;
        }

        if (status) {
          status.classList.toggle("is-unavailable", !available);
          status.textContent = available ? "UNIT IN STOCK - DEPLOY READY" : "UNIT OFFLINE - SOLD OUT";
        }
      }

      form.querySelectorAll("[data-ac-option-choice]").forEach((choice) => {
        choice.addEventListener("click", () => {
          const group = choice.closest("[data-ac-option-group]");
          if (!group) return;

          group.querySelectorAll("[data-ac-option-choice]").forEach((item) => {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });

          choice.classList.add("is-active");
          choice.setAttribute("aria-pressed", "true");

          const label = group.querySelector(`[data-ac-option-label="${choice.dataset.optionPosition}"]`);
          if (label) label.textContent = choice.dataset.value.toUpperCase();

          setVariant(choice);
        });
      });

      setVariant();
    });
  }

  function initCollectionPage(root = document) {
    root.querySelectorAll("[data-ac-collection-page]:not([data-ac-collection-ready])").forEach((page) => {
      page.dataset.acCollectionReady = "true";
      const cards = Array.from(page.querySelectorAll("[data-ac-product-card]"));
      const unitCount = page.querySelector("[data-ac-unit-count]");
      const grid = page.querySelector("[data-ac-collection-grid]");

      function updateCount(count) {
        if (!unitCount) return;
        unitCount.textContent = `${count} UNIT${count === 1 ? "" : "S"}`;
      }

      page.querySelectorAll("[data-ac-filter]").forEach((button) => {
        button.addEventListener("click", () => {
          const filter = button.dataset.acFilter;
          let visible = 0;

          page.querySelectorAll("[data-ac-filter]").forEach((item) => {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });
          button.classList.add("is-active");
          button.setAttribute("aria-pressed", "true");

          cards.forEach((card) => {
            const matches = filter === "ALL" || card.dataset.cat === filter;
            card.classList.toggle("is-filtered-out", !matches);
            card.setAttribute("aria-hidden", matches ? "false" : "true");
            if (matches) visible += 1;
          });

          updateCount(visible);
        });
      });

      page.querySelectorAll("[data-ac-view]").forEach((button) => {
        button.addEventListener("click", () => {
          if (!grid) return;
          const view = button.dataset.acView;

          page.querySelectorAll("[data-ac-view]").forEach((item) => {
            item.classList.remove("is-active");
            item.setAttribute("aria-pressed", "false");
          });
          button.classList.add("is-active");
          button.setAttribute("aria-pressed", "true");

          grid.classList.remove("is-view-1", "is-view-2", "is-view-3", "is-view-4");
          grid.classList.add(`is-view-${view}`);
        });
      });

      updateCount(cards.length);
    });
  }

  function initAboutPage(root = document) {
    root.querySelectorAll("[data-ac-about-page]:not([data-ac-about-ready])").forEach((page) => {
      page.dataset.acAboutReady = "true";

      const heroCanvas = page.querySelector("[data-ac-about-hero-canvas]");
      if (heroCanvas) {
        const context = heroCanvas.getContext("2d");
        const cols = 24;
        const rows = 14;
        let width = 0;
        let height = 0;
        let points = [];
        let tick = 0;
        const mouse = { x: 0, y: 0 };

        function buildGrid() {
          points = [];
          for (let row = 0; row < rows; row += 1) {
            for (let col = 0; col < cols; col += 1) {
              points.push({
                bx: (col / (cols - 1)) * width,
                by: (row / (rows - 1)) * height,
                x: 0,
                y: 0,
                phase: Math.random() * Math.PI * 2,
                amp: 4 + Math.random() * 8,
              });
            }
          }
        }

        function resizeHero() {
          width = heroCanvas.offsetWidth;
          height = heroCanvas.offsetHeight;
          heroCanvas.width = width;
          heroCanvas.height = height;
          buildGrid();
        }

        function drawHero() {
          if (!context || !width || !height) return;
          context.clearRect(0, 0, width, height);
          tick += 0.008;

          points.forEach((point) => {
            const wave = Math.sin(tick + point.phase) * point.amp;
            point.x = point.bx + wave;
            point.y = point.by + wave * 0.6;

            const dx = mouse.x - point.x;
            const dy = mouse.y - point.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < 120) {
              const force = (120 - dist) / 120;
              point.x -= dx * force * 0.04;
              point.y -= dy * force * 0.04;
            }
          });

          for (let i = 0; i < points.length; i += 1) {
            for (let j = i + 1; j < points.length; j += 1) {
              const dx = points[i].x - points[j].x;
              const dy = points[i].y - points[j].y;
              const dist = Math.sqrt(dx * dx + dy * dy);
              const maxDist = (width / cols) * 1.8;
              if (dist < maxDist) {
                context.beginPath();
                context.strokeStyle = `rgba(240, 240, 238, ${(1 - dist / maxDist) * 0.12})`;
                context.lineWidth = 0.5;
                context.moveTo(points[i].x, points[i].y);
                context.lineTo(points[j].x, points[j].y);
                context.stroke();
              }
            }
          }

          points.forEach((point) => {
            context.beginPath();
            context.arc(point.x, point.y, 1, 0, Math.PI * 2);
            context.fillStyle = "rgba(240, 240, 238, 0.25)";
            context.fill();
          });

          const scanLine = (tick * 60) % height;
          const scanGradient = context.createLinearGradient(0, scanLine - 60, 0, scanLine + 60);
          scanGradient.addColorStop(0, "rgba(240, 240, 238, 0)");
          scanGradient.addColorStop(0.5, "rgba(240, 240, 238, 0.04)");
          scanGradient.addColorStop(1, "rgba(240, 240, 238, 0)");
          context.fillStyle = scanGradient;
          context.fillRect(0, scanLine - 60, width, 120);

          requestAnimationFrame(drawHero);
        }

        heroCanvas.addEventListener("mousemove", (event) => {
          const rect = heroCanvas.getBoundingClientRect();
          mouse.x = event.clientX - rect.left;
          mouse.y = event.clientY - rect.top;
        });

        resizeHero();
        window.addEventListener("resize", resizeHero);
        drawHero();
      }

      const globe = page.querySelector("[data-ac-about-globe]");
      if (globe) {
        const context = globe.getContext("2d");
        const london = { lat: 51.5074, lng: -0.1278, label: "LONDON" };
        const porto = { lat: 41.1579, lng: -8.6291, label: "PORTO" };
        let width = 0;
        let height = 0;
        let tick = 0;

        function resizeGlobe() {
          width = globe.offsetWidth;
          height = globe.offsetHeight;
          globe.width = width;
          globe.height = height;
        }

        function toXY(lat, lng, centerX, centerY, radius, rotation) {
          const latitude = lat * Math.PI / 180;
          const longitude = (lng + rotation) * Math.PI / 180;
          return {
            x: centerX + radius * Math.cos(latitude) * Math.sin(longitude),
            y: centerY - radius * Math.sin(latitude),
            z: Math.cos(latitude) * Math.cos(longitude),
          };
        }

        function plotCity(city, centerX, centerY, radius, rotation) {
          const point = toXY(city.lat, city.lng, centerX, centerY, radius, rotation);
          if (point.z < -0.2) return;
          const alpha = Math.max(0, (point.z + 0.2) / 0.8);
          const pulse = (Math.sin(tick * 3 + city.lat) * 0.5 + 0.5) * 0.6 + 0.4;

          context.beginPath();
          context.arc(point.x, point.y, 3, 0, Math.PI * 2);
          context.fillStyle = `rgba(240, 240, 238, ${alpha * pulse})`;
          context.fill();

          context.beginPath();
          context.arc(point.x, point.y, 6 + Math.sin(tick * 2 + city.lat) * 3, 0, Math.PI * 2);
          context.strokeStyle = `rgba(240, 240, 238, ${alpha * 0.2})`;
          context.lineWidth = 1;
          context.stroke();

          context.fillStyle = `rgba(240, 240, 238, ${alpha * 0.6})`;
          context.font = "700 8px Space Mono, monospace";
          context.fillText(city.label, point.x + 8, point.y + 3);
        }

        function drawGlobe() {
          if (!context || !width || !height) return;
          context.clearRect(0, 0, width, height);
          tick += 0.005;

          const rotation = tick * (180 / Math.PI);
          const centerX = width / 2;
          const centerY = height / 2;
          const radius = Math.min(width, height) * 0.38;

          context.beginPath();
          context.arc(centerX, centerY, radius, 0, Math.PI * 2);
          context.strokeStyle = "rgba(240, 240, 238, 0.08)";
          context.lineWidth = 1;
          context.stroke();

          for (let lat = -60; lat <= 60; lat += 30) {
            const latRadians = lat * Math.PI / 180;
            context.beginPath();
            context.ellipse(centerX, centerY - radius * Math.sin(latRadians), radius * Math.cos(latRadians), radius * Math.cos(latRadians) * 0.25, 0, 0, Math.PI * 2);
            context.strokeStyle = "rgba(240, 240, 238, 0.05)";
            context.lineWidth = 0.5;
            context.stroke();
          }

          context.beginPath();
          let started = false;
          for (let i = 0; i <= 60; i += 1) {
            const progress = i / 60;
            const lat = london.lat + (porto.lat - london.lat) * progress + Math.sin(progress * Math.PI);
            const lng = london.lng + (porto.lng - london.lng) * progress;
            const point = toXY(lat, lng, centerX, centerY, radius, rotation);
            if (point.z < -0.1) continue;
            if (!started) {
              context.moveTo(point.x, point.y);
              started = true;
            } else {
              context.lineTo(point.x, point.y);
            }
          }
          context.strokeStyle = `rgba(240, 240, 238, ${0.25 + Math.sin(tick) * 0.1})`;
          context.lineWidth = 1;
          context.setLineDash([3, 4]);
          context.stroke();
          context.setLineDash([]);

          plotCity(london, centerX, centerY, radius, rotation);
          plotCity(porto, centerX, centerY, radius, rotation);
          requestAnimationFrame(drawGlobe);
        }

        resizeGlobe();
        window.addEventListener("resize", resizeGlobe);
        drawGlobe();
      }

      const noise = page.querySelector("[data-ac-about-noise]");
      if (noise) {
        for (let i = 0; i < 12; i += 1) {
          const line = document.createElement("span");
          line.className = "aca-noise-line";
          line.style.top = `${(i / 11) * 100}%`;
          line.style.setProperty("--aca-line-duration", `${8 + Math.random() * 12}s`);
          line.style.animationDelay = `${-Math.random() * 10}s`;
          line.style.opacity = `${0.3 + Math.random() * 0.4}`;
          noise.appendChild(line);
        }
      }

      const bgWord = page.querySelector("[data-ac-about-bg-word]");
      const glitch = page.querySelector("[data-ac-about-glitch]");

      window.addEventListener("scroll", () => {
        if (!bgWord) return;
        const section = bgWord.closest(".aca-manifesto");
        const rect = section.getBoundingClientRect();
        const relative = (rect.top + rect.height / 2 - window.innerHeight / 2) / window.innerHeight;
        bgWord.style.transform = `translate(-50%, -50%) translateY(${relative * -60}px)`;
      }, { passive: true });

      page.addEventListener("mousemove", (event) => {
        if (!glitch) return;
        const mx = (event.clientX / window.innerWidth - 0.5) * 30;
        const my = (event.clientY / window.innerHeight - 0.5) * 15;
        glitch.style.transform = `translate(calc(-50% + ${mx}px), calc(-50% + ${my}px))`;
      });
    });
  }

  function initContactPage(root = document) {
    root.querySelectorAll("[data-ac-contact-page]:not([data-ac-contact-ready])").forEach((page) => {
      page.dataset.acContactReady = "true";

      page.querySelectorAll("[data-ac-contact-title-line]").forEach((line, index) => {
        window.setTimeout(() => line.classList.add("is-visible"), 200 + index * 140);
      });

      const heroWord = page.querySelector("[data-ac-contact-hero-word]");
      if (heroWord) {
        let scrollOffset = 0;
        let mouseX = 0;
        let mouseY = 0;

        function renderHeroWord() {
          heroWord.style.transform = `translateY(${scrollOffset}px) translate(${mouseX}px, ${mouseY}px)`;
        }

        window.addEventListener("scroll", () => {
          scrollOffset = window.scrollY * 0.12;
          renderHeroWord();
        }, { passive: true });

        page.addEventListener("mousemove", (event) => {
          mouseX = (event.clientX / window.innerWidth - 0.5) * 24;
          mouseY = (event.clientY / window.innerHeight - 0.5) * 12;
          renderHeroWord();
        });
      }

      const signalCanvas = page.querySelector("[data-ac-contact-signal]");
      if (signalCanvas) {
        const context = signalCanvas.getContext("2d");
        let width = 0;
        let height = 0;
        let tick = 0;
        const mouse = { x: 0.5, y: 0.5 };
        const waves = Array.from({ length: 5 }, (_, index) => ({
          phase: Math.random() * Math.PI * 2,
          amp: 18 + index * 12,
          y: (index + 1) / 6,
          speed: 0.003 + index * 0.001,
          alpha: 0.04 + index * 0.015,
        }));
        const particles = Array.from({ length: 50 }, () => ({
          x: Math.random(),
          y: Math.random(),
          vx: (Math.random() - 0.5) * 0.0004,
          vy: (Math.random() - 0.5) * 0.0004,
          r: Math.random() * 1.2 + 0.3,
          alpha: Math.random() * 0.15 + 0.03,
        }));

        function resizeSignal() {
          width = signalCanvas.offsetWidth;
          height = signalCanvas.offsetHeight;
          signalCanvas.width = width;
          signalCanvas.height = height;
        }

        function drawSignal() {
          if (!context || !width || !height) return;
          context.clearRect(0, 0, width, height);
          tick += 1;

          waves.forEach((wave) => {
            context.beginPath();
            for (let x = 0; x <= width; x += 2) {
              const nx = x / width;
              const distort = Math.sin(nx * Math.PI * 3 + tick * wave.speed + wave.phase) * wave.amp;
              const mouseInfluence = (1 - Math.abs(nx - mouse.x)) * 12;
              const y = wave.y * height + distort + mouseInfluence * (mouse.y - 0.5) * 20;
              if (x === 0) context.moveTo(x, y);
              else context.lineTo(x, y);
            }
            context.strokeStyle = `rgba(240, 240, 238, ${wave.alpha})`;
            context.lineWidth = 0.8;
            context.stroke();
          });

          particles.forEach((particle) => {
            particle.x += particle.vx;
            particle.y += particle.vy;
            if (particle.x < 0) particle.x = 1;
            if (particle.x > 1) particle.x = 0;
            if (particle.y < 0) particle.y = 1;
            if (particle.y > 1) particle.y = 0;

            const dx = mouse.x - particle.x;
            const dy = mouse.y - particle.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < 0.15) {
              particle.vx += dx * 0.00003;
              particle.vy += dy * 0.00003;
            }

            context.beginPath();
            context.arc(particle.x * width, particle.y * height, particle.r, 0, Math.PI * 2);
            context.fillStyle = `rgba(240, 240, 238, ${particle.alpha})`;
            context.fill();
          });

          const scanY = (tick * 0.4) % height;
          const scanGradient = context.createLinearGradient(0, scanY - 40, 0, scanY + 40);
          scanGradient.addColorStop(0, "rgba(240, 240, 238, 0)");
          scanGradient.addColorStop(0.5, "rgba(240, 240, 238, 0.03)");
          scanGradient.addColorStop(1, "rgba(240, 240, 238, 0)");
          context.fillStyle = scanGradient;
          context.fillRect(0, scanY - 40, width, 80);

          context.strokeStyle = "rgba(240, 240, 238, 0.06)";
          context.lineWidth = 0.5;
          context.beginPath();
          context.moveTo(mouse.x * width, 0);
          context.lineTo(mouse.x * width, height);
          context.stroke();
          context.beginPath();
          context.moveTo(0, mouse.y * height);
          context.lineTo(width, mouse.y * height);
          context.stroke();
          context.beginPath();
          context.arc(mouse.x * width, mouse.y * height, 16, 0, Math.PI * 2);
          context.strokeStyle = "rgba(240, 240, 238, 0.08)";
          context.stroke();

          requestAnimationFrame(drawSignal);
        }

        page.addEventListener("mousemove", (event) => {
          const rect = signalCanvas.getBoundingClientRect();
          mouse.x = (event.clientX - rect.left) / Math.max(1, rect.width);
          mouse.y = (event.clientY - rect.top) / Math.max(1, rect.height);
        });

        resizeSignal();
        window.addEventListener("resize", resizeSignal);
        drawSignal();
      }

      const nodeCanvas = page.querySelector("[data-ac-contact-node]");
      if (nodeCanvas) {
        const context = nodeCanvas.getContext("2d");
        const london = { x: 0.62, y: 0.25, label: "LONDON" };
        const porto = { x: 0.48, y: 0.35, label: "PORTO" };
        let width = 0;
        let height = 0;
        let tick = 0;

        function resizeNode() {
          width = nodeCanvas.offsetWidth;
          height = nodeCanvas.offsetHeight;
          nodeCanvas.width = width;
          nodeCanvas.height = height;
        }

        function drawNode() {
          if (!context || !width || !height) return;
          context.clearRect(0, 0, width, height);
          tick += 0.02;

          for (let gx = 0; gx < width; gx += 20) {
            for (let gy = 0; gy < height; gy += 20) {
              context.beginPath();
              context.arc(gx, gy, 0.5, 0, Math.PI * 2);
              context.fillStyle = "rgba(240, 240, 238, 0.06)";
              context.fill();
            }
          }

          context.setLineDash([4, 6]);
          context.lineDashOffset = -tick * 2;
          context.beginPath();
          context.moveTo(london.x * width, london.y * height);
          context.quadraticCurveTo((london.x + porto.x) * width / 2, ((london.y + porto.y) / 2 - 0.08) * height, porto.x * width, porto.y * height);
          context.strokeStyle = "rgba(240, 240, 238, 0.2)";
          context.lineWidth = 1;
          context.stroke();
          context.setLineDash([]);

          [london, porto].forEach((node) => {
            const px = node.x * width;
            const py = node.y * height;
            const pulse = (Math.sin(tick + node.x) * 0.5 + 0.5) * 0.6 + 0.4;
            [16, 10, 5].forEach((radius, index) => {
              context.beginPath();
              context.arc(px, py, radius * (pulse * 0.3 + 0.7), 0, Math.PI * 2);
              context.strokeStyle = `rgba(74, 222, 128, ${[0.06, 0.12, 0.3][index]})`;
              context.lineWidth = 1;
              context.stroke();
            });
            context.beginPath();
            context.arc(px, py, 3, 0, Math.PI * 2);
            context.fillStyle = `rgba(74, 222, 128, ${pulse})`;
            context.fill();
            context.fillStyle = "rgba(240, 240, 238, 0.5)";
            context.font = "700 8px Space Mono, monospace";
            context.fillText(node.label, px + 12, py + 3);
          });

          requestAnimationFrame(drawNode);
        }

        resizeNode();
        window.addEventListener("resize", resizeNode);
        drawNode();
      }

      const log = page.querySelector("[data-ac-contact-live-log]");
      function addLog(message) {
        if (!log) return;
        const now = new Date();
        const stamp = `${pad(now.getHours())}:${pad(now.getMinutes())}:${pad(now.getSeconds())}`;
        const line = document.createElement("p");
        line.innerHTML = `<span>[${stamp}]</span> ${message}`;
        log.appendChild(line);
        while (log.children.length > 8) log.removeChild(log.firstChild);
      }

      page.querySelectorAll("[data-ac-contact-query-group] button").forEach((button) => {
        button.addEventListener("click", () => {
          const group = button.closest("[data-ac-contact-query-group]");
          const input = page.querySelector("[data-ac-contact-query-value]");
          const select = page.querySelector("[data-ac-contact-query-select]");
          group.querySelectorAll("button").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          if (input) input.value = button.dataset.value;
          if (select) select.value = button.dataset.value;
          addLog(`QUERY TYPE SET: <b>${button.dataset.value}</b>`);
        });
      });

      const querySelect = page.querySelector("[data-ac-contact-query-select]");
      if (querySelect) {
        querySelect.addEventListener("change", () => {
          const input = page.querySelector("[data-ac-contact-query-value]");
          const value = querySelect.value;
          if (input) input.value = value;
          page.querySelectorAll("[data-ac-contact-query-group] button").forEach((button) => {
            button.classList.toggle("is-selected", button.dataset.value === value);
          });
          addLog(`QUERY TYPE SET: <b>${value}</b>`);
        });
      }

      page.querySelectorAll("[data-ac-contact-priority-group] button").forEach((button) => {
        button.addEventListener("click", () => {
          const group = button.closest("[data-ac-contact-priority-group]");
          const input = page.querySelector("[data-ac-contact-priority-value]");
          group.querySelectorAll("button").forEach((item) => item.classList.remove("is-selected"));
          button.classList.add("is-selected");
          if (input) input.value = button.dataset.value;
          addLog(`PRIORITY: <b>${button.dataset.value}</b>`);
        });
      });

      const subject = page.querySelector("[data-ac-contact-subject]");
      const subjectCount = page.querySelector("[data-ac-contact-subject-count]");
      if (subject && subjectCount) {
        subject.addEventListener("input", () => {
          const count = subject.value.length;
          subjectCount.textContent = `${count}/80`;
          subjectCount.classList.toggle("is-warn", count > 68);
          subjectCount.classList.toggle("is-over", count >= 80);
        });
      }

      const message = page.querySelector("[data-ac-contact-message]");
      const messageCount = page.querySelector("[data-ac-contact-message-count]");
      if (message && messageCount) {
        message.addEventListener("input", () => {
          const count = message.value.length;
          messageCount.textContent = `${count}/1000`;
          messageCount.classList.toggle("is-warn", count > 800);
          messageCount.classList.toggle("is-over", count >= 1000);
        });
      }

      const attach = page.querySelector("[data-ac-contact-attach]");
      if (attach) {
        attach.addEventListener("change", () => {
          if (attach.files.length > 0) addLog(`ATTACHMENT: <b>${attach.files.length} FILE(S) SELECTED</b>`);
        });
      }

      page.querySelectorAll("[data-ac-contact-field-log]").forEach((input) => {
        input.addEventListener("focus", () => {
          addLog(`FIELD ACTIVE: <b>${input.dataset.acContactFieldLog}</b>`);
        });
      });

      const form = page.querySelector("[data-ac-contact-form]");
      const submit = page.querySelector("[data-ac-contact-submit]");
      if (form && submit) {
        form.addEventListener("submit", () => {
          submit.textContent = "TRANSMITTING...";
          submit.disabled = true;
          addLog("ROUTING TO NODE LAX-01...");
        });
      }

      const today = new Date().getDay();
      page.querySelectorAll(".acn-hours [data-day]").forEach((row) => {
        row.classList.toggle("is-today", Number(row.dataset.day) === today);
      });
    });
  }

  function initFAQPage(root = document) {
    root.querySelectorAll("[data-ac-faq-page]:not([data-ac-faq-ready])").forEach((page) => {
      page.dataset.acFaqReady = "true";

      page.querySelectorAll("[data-ac-faq-title-line]").forEach((line, index) => {
        window.setTimeout(() => line.classList.add("is-visible"), 300 + index * 120);
      });

      const heroNumeral = page.querySelector("[data-ac-faq-hero-numeral]");
      if (heroNumeral) {
        let scrollOffset = 0;
        let mouseX = 0;
        let mouseY = 0;

        function renderNumeral() {
          heroNumeral.style.transform = `translateY(calc(-50% + ${scrollOffset}px)) translate(${mouseX}px, ${mouseY}px)`;
        }

        window.addEventListener("scroll", () => {
          scrollOffset = window.scrollY * 0.2;
          renderNumeral();
        }, { passive: true });

        page.addEventListener("mousemove", (event) => {
          mouseX = (event.clientX / window.innerWidth - 0.5) * 20;
          mouseY = (event.clientY / window.innerHeight - 0.5) * 10;
          renderNumeral();
        });
      }

      const items = Array.from(page.querySelectorAll("[data-ac-faq-item]"));
      const sections = Array.from(page.querySelectorAll("[data-ac-faq-section]"));
      const sidebarItems = Array.from(page.querySelectorAll("[data-ac-faq-sidebar]"));
      const total = page.querySelector("[data-ac-faq-total]");
      const search = page.querySelector("[data-ac-faq-search]");
      const clear = page.querySelector("[data-ac-faq-search-clear]");
      const searchCount = page.querySelector("[data-ac-faq-search-count]");
      const empty = page.querySelector("[data-ac-faq-empty]");
      const contact = page.querySelector("[data-ac-faq-contact]");
      const sidebar = page.querySelector(".acf-sidebar");
      let sidebarSpacer = null;
      let sidebarNaturalTop = 0;
      let sidebarHeight = 0;
      let sidebarTicking = false;

      function getFAQSidebarOffset() {
        const chrome = document.querySelector(".auciel-control-chrome");
        const source = chrome || document.documentElement;
        const value = window.getComputedStyle(source).getPropertyValue("--ac-nav-total-h");
        const parsed = Number.parseFloat(value);
        return Number.isFinite(parsed) ? parsed : 84;
      }

      function ensureFAQSidebarSpacer() {
        if (!sidebar) return null;
        if (!sidebarSpacer) {
          sidebarSpacer = document.createElement("div");
          sidebarSpacer.className = "acf-sidebar-spacer";
          sidebarSpacer.setAttribute("aria-hidden", "true");
          sidebar.after(sidebarSpacer);
        }

        return sidebarSpacer;
      }

      function measureFAQSidebar() {
        if (!sidebar) return;

        const wasStuck = sidebar.classList.contains("is-mobile-stuck");
        const spacer = ensureFAQSidebarSpacer();

        if (wasStuck) sidebar.classList.remove("is-mobile-stuck");
        if (spacer) spacer.style.height = "0px";

        const rect = sidebar.getBoundingClientRect();
        sidebarNaturalTop = rect.top + window.scrollY;
        sidebarHeight = rect.height;

        if (wasStuck) sidebar.classList.add("is-mobile-stuck");
      }

      function updateFAQSidebarStick() {
        sidebarTicking = false;
        if (!sidebar) return;

        const spacer = ensureFAQSidebarSpacer();
        const isMobile = window.matchMedia("(max-width: 960px)").matches;

        if (!isMobile) {
          sidebar.classList.remove("is-mobile-stuck");
          if (spacer) spacer.style.height = "0px";
          return;
        }

        const offset = getFAQSidebarOffset();
        sidebar.style.setProperty("--acf-mobile-stuck-top", `${offset}px`);

        if (!sidebarNaturalTop || !sidebarHeight) measureFAQSidebar();

        const shouldStick = window.scrollY + offset >= sidebarNaturalTop;
        sidebar.classList.toggle("is-mobile-stuck", shouldStick);
        if (spacer) spacer.style.height = shouldStick ? `${sidebarHeight}px` : "0px";
      }

      function requestFAQSidebarStickUpdate() {
        if (sidebarTicking) return;
        sidebarTicking = true;
        window.requestAnimationFrame(updateFAQSidebarStick);
      }

      if (sidebar) {
        ensureFAQSidebarSpacer();
        window.setTimeout(() => {
          measureFAQSidebar();
          updateFAQSidebarStick();
        }, 0);
        window.addEventListener("scroll", requestFAQSidebarStickUpdate, { passive: true });
        window.addEventListener("resize", () => {
          measureFAQSidebar();
          updateFAQSidebarStick();
        });
      }

      function closeItem(item) {
        const body = item.querySelector(".acf-body");
        item.classList.remove("is-open");
        if (body) body.style.maxHeight = "0";
      }

      function openItem(item) {
        const body = item.querySelector(".acf-body");
        item.classList.add("is-open");
        if (body) body.style.maxHeight = `${body.scrollHeight}px`;
      }

      function setSectionCounts() {
        const counts = {};
        items.forEach((item) => {
          counts[item.dataset.section] = (counts[item.dataset.section] || 0) + 1;
        });

        if (total) total.textContent = String(items.length).padStart(2, "0");

        Object.entries(counts).forEach(([section, count]) => {
          const label = `${count} QUER${count === 1 ? "Y" : "IES"}`;
          page.querySelectorAll(`[data-ac-faq-section-count="${section}"]`).forEach((node) => {
            node.textContent = label;
          });
          page.querySelectorAll(`[data-ac-faq-sidebar-count="${section}"]`).forEach((node) => {
            node.textContent = count;
          });
        });
      }

      items.forEach((item) => {
        const trigger = item.querySelector("[data-ac-faq-trigger]");
        if (!trigger) return;

        trigger.addEventListener("click", () => {
          const section = item.closest("[data-ac-faq-section]");
          const isOpen = item.classList.contains("is-open");

          if (section) {
            section.querySelectorAll("[data-ac-faq-item].is-open").forEach((open) => {
              if (open !== item) closeItem(open);
            });
          }

          if (isOpen) closeItem(item);
          else openItem(item);
        });
      });

      function runSearch() {
        const query = search ? search.value.trim().toLowerCase() : "";

        if (!query) {
          items.forEach((item) => {
            item.hidden = false;
          });
          sections.forEach((section) => {
            section.hidden = false;
          });
          if (empty) empty.style.display = "none";
          if (contact) contact.hidden = false;
          if (searchCount) searchCount.textContent = "";
          if (clear) clear.style.opacity = "0";
          return;
        }

        if (clear) clear.style.opacity = "1";

        let matches = 0;
        items.forEach((item) => {
          const text = item.textContent.toLowerCase();
          const match = text.includes(query);
          item.hidden = !match;
          if (match) {
            matches += 1;
            openItem(item);
          } else {
            closeItem(item);
          }
        });

        sections.forEach((section) => {
          const visible = Array.from(section.querySelectorAll("[data-ac-faq-item]")).some((item) => !item.hidden);
          section.hidden = !visible;
        });

        if (searchCount) searchCount.textContent = `${matches} RESULT${matches === 1 ? "" : "S"}`;
        if (empty) empty.style.display = matches ? "none" : "block";
        if (contact) contact.hidden = matches === 0;
      }

      if (search) search.addEventListener("input", runSearch);
      if (clear) {
        clear.style.opacity = "0";
        clear.addEventListener("click", () => {
          if (!search) return;
          search.value = "";
          runSearch();
          search.focus();
        });
      }

      sidebarItems.forEach((item) => {
        item.addEventListener("click", (event) => {
          event.preventDefault();
          const target = page.querySelector(item.getAttribute("href"));
          if (target) target.scrollIntoView({ behavior: "smooth", block: "start" });
        });
      });

      if ("IntersectionObserver" in window) {
        const sectionObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            const id = entry.target.dataset.acFaqSection;
            sidebarItems.forEach((item) => {
              item.classList.toggle("is-active", item.dataset.acFaqSidebar === id);
            });
          });
        }, { rootMargin: "-30% 0px -65% 0px" });

        sections.forEach((section) => sectionObserver.observe(section));
      }

      setSectionCounts();
      runSearch();
    });
  }

  function init(root = document) {
    activateBody();
    initCursor();
    initClock();
    initBinary();
    initNavChrome(root);
    initReveals(root);
    initParallax();
    initTilt(root);
    initCartDrawer();
    initProductCardSwatches(root);
    initProductRecommendations(root);
    initGlitch(root);
    initSizingTools(root);
    initProductPage(root);
    initCollectionPage(root);
    initAboutPage(root);
    initContactPage(root);
    initFAQPage(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => init());
  } else {
    init();
  }

  document.addEventListener("shopify:section:load", (event) => init(event.target));
})();
